"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWTApiAxiosParamCreator = exports.HydraulicPipeDataApi = exports.HydraulicPipeDataApiFactory = exports.HydraulicPipeDataApiFp = exports.HydraulicPipeDataApiAxiosParamCreator = exports.GoogleAuthorizationApi = exports.GoogleAuthorizationApiFactory = exports.GoogleAuthorizationApiFp = exports.GoogleAuthorizationApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.DatasetsInternalApi = exports.DatasetsInternalApiFactory = exports.DatasetsInternalApiFp = exports.DatasetsInternalApiAxiosParamCreator = exports.DatasetsApi = exports.DatasetsApiFactory = exports.DatasetsApiFp = exports.DatasetsApiAxiosParamCreator = exports.DatasetApi = exports.DatasetApiFactory = exports.DatasetApiFp = exports.DatasetApiAxiosParamCreator = exports.AlertmanagerApi = exports.AlertmanagerApiFactory = exports.AlertmanagerApiFp = exports.AlertmanagerApiAxiosParamCreator = exports.AlertfanTagsApi = exports.AlertfanTagsApiFactory = exports.AlertfanTagsApiFp = exports.AlertfanTagsApiAxiosParamCreator = exports.AlertfanSilencesApi = exports.AlertfanSilencesApiFactory = exports.AlertfanSilencesApiFp = exports.AlertfanSilencesApiAxiosParamCreator = exports.AlertfanHistoryApi = exports.AlertfanHistoryApiFactory = exports.AlertfanHistoryApiFp = exports.AlertfanHistoryApiAxiosParamCreator = exports.AlertfanAlertsApi = exports.AlertfanAlertsApiFactory = exports.AlertfanAlertsApiFp = exports.AlertfanAlertsApiAxiosParamCreator = exports.StatusDTO = exports.SilenceStateDTO = exports.SeverityDTO = exports.HealthStatus = exports.AlertStatus = void 0;
exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.TagApi = exports.TagApiFactory = exports.TagApiFp = exports.TagApiAxiosParamCreator = exports.SoftwareUpdatesApi = exports.SoftwareUpdatesApiFactory = exports.SoftwareUpdatesApiFp = exports.SoftwareUpdatesApiAxiosParamCreator = exports.ServiceConfigurationBackupApi = exports.ServiceConfigurationBackupApiFactory = exports.ServiceConfigurationBackupApiFp = exports.ServiceConfigurationBackupApiAxiosParamCreator = exports.ServerApi = exports.ServerApiFactory = exports.ServerApiFp = exports.ServerApiAxiosParamCreator = exports.SchemeItemApi = exports.SchemeItemApiFactory = exports.SchemeItemApiFp = exports.SchemeItemApiAxiosParamCreator = exports.SchemeChangesApi = exports.SchemeChangesApiFactory = exports.SchemeChangesApiFp = exports.SchemeChangesApiAxiosParamCreator = exports.SchemeApi = exports.SchemeApiFactory = exports.SchemeApiFp = exports.SchemeApiAxiosParamCreator = exports.ReservationApi = exports.ReservationApiFactory = exports.ReservationApiFp = exports.ReservationApiAxiosParamCreator = exports.MigrationHelperApi = exports.MigrationHelperApiFactory = exports.MigrationHelperApiFp = exports.MigrationHelperApiAxiosParamCreator = exports.LicenceApi = exports.LicenceApiFactory = exports.LicenceApiFp = exports.LicenceApiAxiosParamCreator = exports.JWTApi = exports.JWTApiFactory = exports.JWTApiFp = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AlertStatus = {
    Firing: 'FIRING',
    Resolved: 'RESOLVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HealthStatus = {
    Ok: 'OK',
    BadState: 'BAD_STATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SeverityDTO = {
    Debug: 'DEBUG',
    Info: 'INFO',
    Warning: 'WARNING',
    Severe: 'SEVERE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SilenceStateDTO = {
    Expired: 'EXPIRED',
    Active: 'ACTIVE',
    Pending: 'PENDING'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.StatusDTO = {
    Firing: 'FIRING',
    Resolved: 'RESOLVED'
};
/**
 * AlertfanAlertsApi - axios parameter creator
 * @export
 */
const AlertfanAlertsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/alerts/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/alerts/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/alerts/isActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanAlertsApiAxiosParamCreator = AlertfanAlertsApiAxiosParamCreator;
/**
 * AlertfanAlertsApi - functional programming interface
 * @export
 */
const AlertfanAlertsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanAlertsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clearAlerts(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAlerts(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.isActive(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AlertfanAlertsApiFp = AlertfanAlertsApiFp;
/**
 * AlertfanAlertsApi - factory interface
 * @export
 */
const AlertfanAlertsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanAlertsApiFp)(configuration);
    return {
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts(requestBody, options) {
            return localVarFp.clearAlerts(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return localVarFp.getAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(requestBody, options) {
            return localVarFp.isActive(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanAlertsApiFactory = AlertfanAlertsApiFactory;
/**
 * AlertfanAlertsApi - object-oriented interface
 * @export
 * @class AlertfanAlertsApi
 * @extends {BaseAPI}
 */
class AlertfanAlertsApi extends base_1.BaseAPI {
    /**
     *
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanAlertsApi
     */
    clearAlerts(requestBody, options) {
        return (0, exports.AlertfanAlertsApiFp)(this.configuration).clearAlerts(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanAlertsApi
     */
    getAlerts(options) {
        return (0, exports.AlertfanAlertsApiFp)(this.configuration).getAlerts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanAlertsApi
     */
    isActive(requestBody, options) {
        return (0, exports.AlertfanAlertsApiFp)(this.configuration).isActive(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanAlertsApi = AlertfanAlertsApi;
/**
 * AlertfanHistoryApi - axios parameter creator
 * @export
 */
const AlertfanHistoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory: (alertHistoryRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/history/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertHistoryRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanHistoryApiAxiosParamCreator = AlertfanHistoryApiAxiosParamCreator;
/**
 * AlertfanHistoryApi - functional programming interface
 * @export
 */
const AlertfanHistoryApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanHistoryApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(alertHistoryRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistory(alertHistoryRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AlertfanHistoryApiFp = AlertfanHistoryApiFp;
/**
 * AlertfanHistoryApi - factory interface
 * @export
 */
const AlertfanHistoryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanHistoryApiFp)(configuration);
    return {
        /**
         *
         * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistory(alertHistoryRequestDTO, options) {
            return localVarFp.getHistory(alertHistoryRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanHistoryApiFactory = AlertfanHistoryApiFactory;
/**
 * AlertfanHistoryApi - object-oriented interface
 * @export
 * @class AlertfanHistoryApi
 * @extends {BaseAPI}
 */
class AlertfanHistoryApi extends base_1.BaseAPI {
    /**
     *
     * @param {AlertHistoryRequestDTO} [alertHistoryRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanHistoryApi
     */
    getHistory(alertHistoryRequestDTO, options) {
        return (0, exports.AlertfanHistoryApiFp)(this.configuration).getHistory(alertHistoryRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanHistoryApi = AlertfanHistoryApi;
/**
 * AlertfanSilencesApi - axios parameter creator
 * @export
 */
const AlertfanSilencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {SilenceRequestDTO} [silenceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSilence: (silenceRequestDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/silences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(silenceRequestDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSilence: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('deleteSilence', 'id', id);
            const localVarPath = `/alertfan/silences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilence: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('getSilence', 'id', id);
            const localVarPath = `/alertfan/silences/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [showExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilences: (showExpired, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/silences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (showExpired !== undefined) {
                localVarQueryParameter['showExpired'] = showExpired;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanSilencesApiAxiosParamCreator = AlertfanSilencesApiAxiosParamCreator;
/**
 * AlertfanSilencesApi - functional programming interface
 * @export
 */
const AlertfanSilencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanSilencesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {SilenceRequestDTO} [silenceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSilence(silenceRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addSilence(silenceRequestDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSilence(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteSilence(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilence(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSilence(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [showExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilences(showExpired, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSilences(showExpired, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AlertfanSilencesApiFp = AlertfanSilencesApiFp;
/**
 * AlertfanSilencesApi - factory interface
 * @export
 */
const AlertfanSilencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanSilencesApiFp)(configuration);
    return {
        /**
         *
         * @param {SilenceRequestDTO} [silenceRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSilence(silenceRequestDTO, options) {
            return localVarFp.addSilence(silenceRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSilence(id, options) {
            return localVarFp.deleteSilence(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilence(id, options) {
            return localVarFp.getSilence(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [showExpired]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSilences(showExpired, options) {
            return localVarFp.getSilences(showExpired, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanSilencesApiFactory = AlertfanSilencesApiFactory;
/**
 * AlertfanSilencesApi - object-oriented interface
 * @export
 * @class AlertfanSilencesApi
 * @extends {BaseAPI}
 */
class AlertfanSilencesApi extends base_1.BaseAPI {
    /**
     *
     * @param {SilenceRequestDTO} [silenceRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanSilencesApi
     */
    addSilence(silenceRequestDTO, options) {
        return (0, exports.AlertfanSilencesApiFp)(this.configuration).addSilence(silenceRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanSilencesApi
     */
    deleteSilence(id, options) {
        return (0, exports.AlertfanSilencesApiFp)(this.configuration).deleteSilence(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanSilencesApi
     */
    getSilence(id, options) {
        return (0, exports.AlertfanSilencesApiFp)(this.configuration).getSilence(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [showExpired]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanSilencesApi
     */
    getSilences(showExpired, options) {
        return (0, exports.AlertfanSilencesApiFp)(this.configuration).getSilences(showExpired, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanSilencesApi = AlertfanSilencesApi;
/**
 * AlertfanTagsApi - axios parameter creator
 * @export
 */
const AlertfanTagsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommonKnownTags: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/tags/common`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnownTags: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommonKnownTags: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/tags/common`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [hideCommon]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnownTags: (hideCommon, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertfan/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (hideCommon !== undefined) {
                localVarQueryParameter['hideCommon'] = hideCommon;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanTagsApiAxiosParamCreator = AlertfanTagsApiAxiosParamCreator;
/**
 * AlertfanTagsApi - functional programming interface
 * @export
 */
const AlertfanTagsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanTagsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommonKnownTags(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addCommonKnownTags(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnownTags(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addKnownTags(requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommonKnownTags(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCommonKnownTags(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [hideCommon]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnownTags(hideCommon, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKnownTags(hideCommon, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AlertfanTagsApiFp = AlertfanTagsApiFp;
/**
 * AlertfanTagsApi - factory interface
 * @export
 */
const AlertfanTagsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanTagsApiFp)(configuration);
    return {
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCommonKnownTags(requestBody, options) {
            return localVarFp.addCommonKnownTags(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addKnownTags(requestBody, options) {
            return localVarFp.addKnownTags(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommonKnownTags(options) {
            return localVarFp.getCommonKnownTags(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [hideCommon]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKnownTags(hideCommon, options) {
            return localVarFp.getKnownTags(hideCommon, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanTagsApiFactory = AlertfanTagsApiFactory;
/**
 * AlertfanTagsApi - object-oriented interface
 * @export
 * @class AlertfanTagsApi
 * @extends {BaseAPI}
 */
class AlertfanTagsApi extends base_1.BaseAPI {
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanTagsApi
     */
    addCommonKnownTags(requestBody, options) {
        return (0, exports.AlertfanTagsApiFp)(this.configuration).addCommonKnownTags(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanTagsApi
     */
    addKnownTags(requestBody, options) {
        return (0, exports.AlertfanTagsApiFp)(this.configuration).addKnownTags(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanTagsApi
     */
    getCommonKnownTags(options) {
        return (0, exports.AlertfanTagsApiFp)(this.configuration).getCommonKnownTags(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [hideCommon]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanTagsApi
     */
    getKnownTags(hideCommon, options) {
        return (0, exports.AlertfanTagsApiFp)(this.configuration).getKnownTags(hideCommon, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanTagsApi = AlertfanTagsApi;
/**
 * AlertmanagerApi - axios parameter creator
 * @export
 */
const AlertmanagerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {WebhookDTO} [webhookDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertmanagerAlertWebhookPost: (webhookDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/alertmanager/alertWebhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(webhookDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertmanagerApiAxiosParamCreator = AlertmanagerApiAxiosParamCreator;
/**
 * AlertmanagerApi - functional programming interface
 * @export
 */
const AlertmanagerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertmanagerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {WebhookDTO} [webhookDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertmanagerAlertWebhookPost(webhookDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.alertmanagerAlertWebhookPost(webhookDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AlertmanagerApiFp = AlertmanagerApiFp;
/**
 * AlertmanagerApi - factory interface
 * @export
 */
const AlertmanagerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertmanagerApiFp)(configuration);
    return {
        /**
         *
         * @param {WebhookDTO} [webhookDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertmanagerAlertWebhookPost(webhookDTO, options) {
            return localVarFp.alertmanagerAlertWebhookPost(webhookDTO, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertmanagerApiFactory = AlertmanagerApiFactory;
/**
 * AlertmanagerApi - object-oriented interface
 * @export
 * @class AlertmanagerApi
 * @extends {BaseAPI}
 */
class AlertmanagerApi extends base_1.BaseAPI {
    /**
     *
     * @param {WebhookDTO} [webhookDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertmanagerApi
     */
    alertmanagerAlertWebhookPost(webhookDTO, options) {
        return (0, exports.AlertmanagerApiFp)(this.configuration).alertmanagerAlertWebhookPost(webhookDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertmanagerApi = AlertmanagerApi;
/**
 * DatasetApi - axios parameter creator
 * @export
 */
const DatasetApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsByTagsGet: (categoryId, tags, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/byTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            if (tags !== undefined) {
                localVarQueryParameter['tags'] = tags;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCategoriesGet: (categoryIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryIds !== undefined) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCategoryInfoGet: (category, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/categoryInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCountGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentClassDatasetIdGet: (_class, datasetId, adjustContinuous, count, referenceTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataRecentClassDatasetIdGet', '_class', _class);
            // verify required parameter 'datasetId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataRecentClassDatasetIdGet', 'datasetId', datasetId);
            const localVarPath = `/datasets/data/recent/{class}/{datasetId}`
                .replace(`{${"class"}}`, encodeURIComponent(String(_class)))
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (referenceTime !== undefined) {
                localVarQueryParameter['referenceTime'] = (referenceTime instanceof Date) ?
                    referenceTime.toISOString() :
                    referenceTime;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} id
         * @param {BaseDatasetDTO} [baseDatasetDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdPut: (id, baseDatasetDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('datasetsIdPut', 'id', id);
            const localVarPath = `/datasets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(baseDatasetDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdentifierGet: (identifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'identifier' is not null or undefined
            (0, common_1.assertParamExists)('datasetsIdentifierGet', 'identifier', identifier);
            const localVarPath = `/datasets/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdentifierInfoGet: (identifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'identifier' is not null or undefined
            (0, common_1.assertParamExists)('datasetsIdentifierInfoGet', 'identifier', identifier);
            const localVarPath = `/datasets/{identifier}/info`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsInfosGet: (page, query, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/infos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DatasetRequestFilter} [datasetRequestFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsPost: (datasetRequestFilter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetRequestFilter, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSearchCountGet: (identifiers, query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/search/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Find datasets by query
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSearchGet: (identifiers, limit, query, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (identifiers !== undefined) {
                localVarQueryParameter['identifiers'] = identifiers;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetApiAxiosParamCreator = DatasetApiAxiosParamCreator;
/**
 * DatasetApi - functional programming interface
 * @export
 */
const DatasetApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsByTagsGet(categoryId, tags, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsByTagsGet(categoryId, tags, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCategoriesGet(categoryIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsCategoriesGet(categoryIds, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCategoryInfoGet(category, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsCategoryInfoGet(category, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCountGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsCountGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentClassDatasetIdGet(_class, datasetId, adjustContinuous, count, referenceTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsDataRecentClassDatasetIdGet(_class, datasetId, adjustContinuous, count, referenceTime, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {object} id
         * @param {BaseDatasetDTO} [baseDatasetDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdPut(id, baseDatasetDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsIdPut(id, baseDatasetDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {object} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdentifierGet(identifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsIdentifierGet(identifier, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {object} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdentifierInfoGet(identifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsIdentifierInfoGet(identifier, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsInfosGet(page, query, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsInfosGet(page, query, size, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {DatasetRequestFilter} [datasetRequestFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsPost(datasetRequestFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsPost(datasetRequestFilter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSearchCountGet(identifiers, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsSearchCountGet(identifiers, query, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Find datasets by query
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSearchGet(identifiers, limit, query, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsSearchGet(identifiers, limit, query, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DatasetApiFp = DatasetApiFp;
/**
 * DatasetApi - factory interface
 * @export
 */
const DatasetApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [categoryId]
         * @param {string} [tags]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsByTagsGet(categoryId, tags, options) {
            return localVarFp.datasetsByTagsGet(categoryId, tags, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [categoryIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCategoriesGet(categoryIds, options) {
            return localVarFp.datasetsCategoriesGet(categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [category]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCategoryInfoGet(category, options) {
            return localVarFp.datasetsCategoryInfoGet(category, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsCountGet(options) {
            return localVarFp.datasetsCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} _class
         * @param {number} datasetId
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentClassDatasetIdGet(_class, datasetId, adjustContinuous, count, referenceTime, options) {
            return localVarFp.datasetsDataRecentClassDatasetIdGet(_class, datasetId, adjustContinuous, count, referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} id
         * @param {BaseDatasetDTO} [baseDatasetDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdPut(id, baseDatasetDTO, options) {
            return localVarFp.datasetsIdPut(id, baseDatasetDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdentifierGet(identifier, options) {
            return localVarFp.datasetsIdentifierGet(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsIdentifierInfoGet(identifier, options) {
            return localVarFp.datasetsIdentifierInfoGet(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [page]
         * @param {string} [query]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsInfosGet(page, query, size, options) {
            return localVarFp.datasetsInfosGet(page, query, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DatasetRequestFilter} [datasetRequestFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsPost(datasetRequestFilter, options) {
            return localVarFp.datasetsPost(datasetRequestFilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [identifiers]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSearchCountGet(identifiers, query, options) {
            return localVarFp.datasetsSearchCountGet(identifiers, query, options).then((request) => request(axios, basePath));
        },
        /**
         * Find datasets by query
         * @param {string} [identifiers]
         * @param {number} [limit]
         * @param {string} [query]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSearchGet(identifiers, limit, query, options) {
            return localVarFp.datasetsSearchGet(identifiers, limit, query, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetApiFactory = DatasetApiFactory;
/**
 * DatasetApi - object-oriented interface
 * @export
 * @class DatasetApi
 * @extends {BaseAPI}
 */
class DatasetApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [categoryId]
     * @param {string} [tags]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsByTagsGet(categoryId, tags, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsByTagsGet(categoryId, tags, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [categoryIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsCategoriesGet(categoryIds, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsCategoriesGet(categoryIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsCategoryInfoGet(category, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsCategoryInfoGet(category, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsCountGet(options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsCountGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} _class
     * @param {number} datasetId
     * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
     * @param {number} [count]
     * @param {string} [referenceTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsDataRecentClassDatasetIdGet(_class, datasetId, adjustContinuous, count, referenceTime, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsDataRecentClassDatasetIdGet(_class, datasetId, adjustContinuous, count, referenceTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} id
     * @param {BaseDatasetDTO} [baseDatasetDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsIdPut(id, baseDatasetDTO, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsIdPut(id, baseDatasetDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsIdentifierGet(identifier, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsIdentifierGet(identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsIdentifierInfoGet(identifier, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsIdentifierInfoGet(identifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [page]
     * @param {string} [query]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsInfosGet(page, query, size, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsInfosGet(page, query, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DatasetRequestFilter} [datasetRequestFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsPost(datasetRequestFilter, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsPost(datasetRequestFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [identifiers]
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsSearchCountGet(identifiers, query, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsSearchCountGet(identifiers, query, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Find datasets by query
     * @param {string} [identifiers]
     * @param {number} [limit]
     * @param {string} [query]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetApi
     */
    datasetsSearchGet(identifiers, limit, query, options) {
        return (0, exports.DatasetApiFp)(this.configuration).datasetsSearchGet(identifiers, limit, query, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetApi = DatasetApi;
/**
 * DatasetsApi - axios parameter creator
 * @export
 */
const DatasetsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {object} [aggregationPeriod]
         * @param {{ [key: string]: object; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataAggregatedInfoPost: (from, to, aggregationPeriod, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'from' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataDataAggregatedInfoPost', 'from', from);
            // verify required parameter 'to' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataDataAggregatedInfoPost', 'to', to);
            const localVarPath = `/datasetData/dataAggregatedInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregationPeriod !== undefined) {
                localVarQueryParameter['aggregationPeriod'] = aggregationPeriod;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataInfoRangePost: (from, to, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasetData/dataInfoRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {Array<object>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataInfoRecentPost: (count, refTime, strict, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasetData/dataInfoRecent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            if (refTime !== undefined) {
                localVarQueryParameter['refTime'] = refTime;
            }
            if (strict !== undefined) {
                localVarQueryParameter['strict'] = strict;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataUpdatePost: (updateDatasetData, log, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateDatasetData' is not null or undefined
            (0, common_1.assertParamExists)('datasetDataUpdatePost', 'updateDatasetData', updateDatasetData);
            const localVarPath = `/datasetData/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (log !== undefined) {
                localVarQueryParameter['log'] = log;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateDatasetData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all allowed datasets for request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsAllowedGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/allowed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @param {object} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {number} from Instant object which represents the start of the data period
         * @param {number} to Instant object which represents the end of the data period
         * @param {{ [key: string]: any; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetsDataIntervalAggregatedPost: (aggregationPeriod, from, to, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'aggregationPeriod' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataIntervalAggregatedPost', 'aggregationPeriod', aggregationPeriod);
            // verify required parameter 'from' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataIntervalAggregatedPost', 'from', from);
            // verify required parameter 'to' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataIntervalAggregatedPost', 'to', to);
            const localVarPath = `/datasets/data/intervalAggregated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (aggregationPeriod !== undefined) {
                localVarQueryParameter['aggregationPeriod'] = aggregationPeriod;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get actual dataset data in the provided data period
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataIntervalDataObjGet: (dataObj, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dataObj' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataIntervalDataObjGet', 'dataObj', dataObj);
            const localVarPath = `/datasets/data/interval/{dataObj}`
                .replace(`{${"dataObj"}}`, encodeURIComponent(String(dataObj)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentDatasetIdGet: (datasetId, adjustContinuous, count, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'datasetId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsDataRecentDatasetIdGet', 'datasetId', datasetId);
            const localVarPath = `/datasets/data/recent/{datasetId}`
                .replace(`{${"datasetId"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }
            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetsDataRecentPost: (alignTimeUnit, lead, leadTimeUnit, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/data/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (alignTimeUnit !== undefined) {
                localVarQueryParameter['alignTimeUnit'] = alignTimeUnit;
            }
            if (lead !== undefined) {
                localVarQueryParameter['lead'] = lead;
            }
            if (leadTimeUnit !== undefined) {
                localVarQueryParameter['leadTimeUnit'] = leadTimeUnit;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentValuesPost: (adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/data/recentValues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (adjustContinuous !== undefined) {
                localVarQueryParameter['adjustContinuous'] = adjustContinuous;
            }
            if (alignTimeUnit !== undefined) {
                localVarQueryParameter['alignTimeUnit'] = alignTimeUnit;
            }
            if (lead !== undefined) {
                localVarQueryParameter['lead'] = lead;
            }
            if (leadTimeUnit !== undefined) {
                localVarQueryParameter['leadTimeUnit'] = leadTimeUnit;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset group object by database id
         * @param {string} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsGroupGet: (groupId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsGroupGet', 'groupId', groupId);
            const localVarPath = `/datasets/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (groupId !== undefined) {
                localVarQueryParameter['groupId'] = groupId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all request user company dataset groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsGroupsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsListGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetsApiAxiosParamCreator = DatasetsApiAxiosParamCreator;
/**
 * DatasetsApi - functional programming interface
 * @export
 */
const DatasetsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {object} [aggregationPeriod]
         * @param {{ [key: string]: object; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataAggregatedInfoPost(from, to, aggregationPeriod, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataDataAggregatedInfoPost(from, to, aggregationPeriod, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataInfoRangePost(from, to, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataDataInfoRangePost(from, to, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {Array<object>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataInfoRecentPost(count, refTime, strict, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataDataInfoRecentPost(count, refTime, strict, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataUpdatePost(updateDatasetData, log, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetDataUpdatePost(updateDatasetData, log, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get all allowed datasets for request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsAllowedGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsAllowedGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @param {object} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {number} from Instant object which represents the start of the data period
         * @param {number} to Instant object which represents the end of the data period
         * @param {{ [key: string]: any; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetsDataIntervalAggregatedPost(aggregationPeriod, from, to, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsDataIntervalAggregatedPost(aggregationPeriod, from, to, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get actual dataset data in the provided data period
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataIntervalDataObjGet(dataObj, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsDataIntervalDataObjGet(dataObj, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentDatasetIdGet(datasetId, adjustContinuous, count, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsDataRecentDatasetIdGet(datasetId, adjustContinuous, count, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetsDataRecentPost(alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsDataRecentPost(alignTimeUnit, lead, leadTimeUnit, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentValuesPost(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsDataRecentValuesPost(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get dataset group object by database id
         * @param {string} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsGroupGet(groupId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsGroupGet(groupId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get all request user company dataset groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsGroupsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsGroupsGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsListGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsListGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DatasetsApiFp = DatasetsApiFp;
/**
 * DatasetsApi - factory interface
 * @export
 */
const DatasetsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {object} [aggregationPeriod]
         * @param {{ [key: string]: object; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataAggregatedInfoPost(from, to, aggregationPeriod, requestBody, options) {
            return localVarFp.datasetDataDataAggregatedInfoPost(from, to, aggregationPeriod, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [from]
         * @param {string} [to]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataInfoRangePost(from, to, requestBody, options) {
            return localVarFp.datasetDataDataInfoRangePost(from, to, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [count]
         * @param {string} [refTime]
         * @param {boolean} [strict]
         * @param {Array<object>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataDataInfoRecentPost(count, refTime, strict, requestBody, options) {
            return localVarFp.datasetDataDataInfoRecentPost(count, refTime, strict, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UpdateDatasetData>} updateDatasetData
         * @param {boolean} [log]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetDataUpdatePost(updateDatasetData, log, options) {
            return localVarFp.datasetDataUpdatePost(updateDatasetData, log, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all allowed datasets for request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsAllowedGet(options) {
            return localVarFp.datasetsAllowedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
         * @param {object} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
         * @param {number} from Instant object which represents the start of the data period
         * @param {number} to Instant object which represents the end of the data period
         * @param {{ [key: string]: any; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetsDataIntervalAggregatedPost(aggregationPeriod, from, to, requestBody, options) {
            return localVarFp.datasetsDataIntervalAggregatedPost(aggregationPeriod, from, to, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get actual dataset data in the provided data period
         * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataIntervalDataObjGet(dataObj, options) {
            return localVarFp.datasetsDataIntervalDataObjGet(dataObj, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
         * @param {number} datasetId Categorized dataset database ID
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {number} [count]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentDatasetIdGet(datasetId, adjustContinuous, count, options) {
            return localVarFp.datasetsDataRecentDatasetIdGet(datasetId, adjustContinuous, count, options).then((request) => request(axios, basePath));
        },
        /**
         * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        datasetsDataRecentPost(alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
            return localVarFp.datasetsDataRecentPost(alignTimeUnit, lead, leadTimeUnit, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
         * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
         * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
         * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
         * @param {string} [leadTimeUnit] Time lead ChronoUnit
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsDataRecentValuesPost(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
            return localVarFp.datasetsDataRecentValuesPost(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset group object by database id
         * @param {string} groupId Dataset group id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsGroupGet(groupId, options) {
            return localVarFp.datasetsGroupGet(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all request user company dataset groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsGroupsGet(options) {
            return localVarFp.datasetsGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all user allowed datasets in DatasetDTO format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsListGet(options) {
            return localVarFp.datasetsListGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetsApiFactory = DatasetsApiFactory;
/**
 * DatasetsApi - object-oriented interface
 * @export
 * @class DatasetsApi
 * @extends {BaseAPI}
 */
class DatasetsApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} from
     * @param {string} to
     * @param {object} [aggregationPeriod]
     * @param {{ [key: string]: object; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetDataDataAggregatedInfoPost(from, to, aggregationPeriod, requestBody, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetDataDataAggregatedInfoPost(from, to, aggregationPeriod, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [from]
     * @param {string} [to]
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetDataDataInfoRangePost(from, to, requestBody, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetDataDataInfoRangePost(from, to, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [count]
     * @param {string} [refTime]
     * @param {boolean} [strict]
     * @param {Array<object>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetDataDataInfoRecentPost(count, refTime, strict, requestBody, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetDataDataInfoRecentPost(count, refTime, strict, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<UpdateDatasetData>} updateDatasetData
     * @param {boolean} [log]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetDataUpdatePost(updateDatasetData, log, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetDataUpdatePost(updateDatasetData, log, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all allowed datasets for request user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsAllowedGet(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsAllowedGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset aggregated data in the provided data period, using the rules defined in query parameters.
     * @param {object} aggregationPeriod ChronoUnit which dictates data aggregation period/frequency
     * @param {number} from Instant object which represents the start of the data period
     * @param {number} to Instant object which represents the end of the data period
     * @param {{ [key: string]: any; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsDataIntervalAggregatedPost(aggregationPeriod, from, to, requestBody, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsDataIntervalAggregatedPost(aggregationPeriod, from, to, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get actual dataset data in the provided data period
     * @param {string} dataObj DatasetDataRequestObject which contains DatasetIdentifier and data period start and end localized time moments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsDataIntervalDataObjGet(dataObj, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsDataIntervalDataObjGet(dataObj, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset most recent value list using current server time. Values are ordered from newest to oldest.
     * @param {number} datasetId Categorized dataset database ID
     * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
     * @param {number} [count]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsDataRecentDatasetIdGet(datasetId, adjustContinuous, count, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsDataRecentDatasetIdGet(datasetId, adjustContinuous, count, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * DEPRECATED. Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
     * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
     * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
     * @param {string} [leadTimeUnit] Time lead ChronoUnit
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsDataRecentPost(alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsDataRecentPost(alignTimeUnit, lead, leadTimeUnit, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset most recent value list using adjusted server time. To calculate adjusted time current server time is truncated to the specified unit and then lead time is added. Most recent values are queried from adjusted time. Values are ordered from newest to oldest.
     * @param {boolean} [adjustContinuous] Jei true, pritempti CONTINUOUS datasetus prie reference time
     * @param {string} [alignTimeUnit] Current server time truncation ChronoUnit
     * @param {number} [lead] Time lead that is added to the current server time. Use negative values for subtraction
     * @param {string} [leadTimeUnit] Time lead ChronoUnit
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsDataRecentValuesPost(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsDataRecentValuesPost(adjustContinuous, alignTimeUnit, lead, leadTimeUnit, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset group object by database id
     * @param {string} groupId Dataset group id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsGroupGet(groupId, options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsGroupGet(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all request user company dataset groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsGroupsGet(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all user allowed datasets in DatasetDTO format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsApi
     */
    datasetsListGet(options) {
        return (0, exports.DatasetsApiFp)(this.configuration).datasetsListGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetsApi = DatasetsApi;
/**
 * DatasetsInternalApi - axios parameter creator
 * @export
 */
const DatasetsInternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @param {ActiveLinksQueryData} [activeLinksQueryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsActiveLinksPost: (activeLinksQueryData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/activeLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activeLinksQueryData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinkIdentifiersGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/linkIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinksDeleteLinkIdDelete: (linkId, schemeId, schemeItemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'linkId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsLinksDeleteLinkIdDelete', 'linkId', linkId);
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsLinksDeleteLinkIdDelete', 'schemeId', schemeId);
            // verify required parameter 'schemeItemId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsLinksDeleteLinkIdDelete', 'schemeItemId', schemeItemId);
            const localVarPath = `/datasets/links/delete/{linkId}`
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (schemeId !== undefined) {
                localVarQueryParameter['schemeId'] = schemeId;
            }
            if (schemeItemId !== undefined) {
                localVarQueryParameter['schemeItemId'] = schemeItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinksGet: (schemeId, schemeItemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsLinksGet', 'schemeId', schemeId);
            // verify required parameter 'schemeItemId' is not null or undefined
            (0, common_1.assertParamExists)('datasetsLinksGet', 'schemeItemId', schemeItemId);
            const localVarPath = `/datasets/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (schemeId !== undefined) {
                localVarQueryParameter['schemeId'] = schemeId;
            }
            if (schemeItemId !== undefined) {
                localVarQueryParameter['schemeItemId'] = schemeItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @param {SchemeItemDatasetLinkHolder} [schemeItemDatasetLinkHolder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSavePost: (schemeItemDatasetLinkHolder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(schemeItemDatasetLinkHolder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsUpdateLinkPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/updateLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetsInternalApiAxiosParamCreator = DatasetsInternalApiAxiosParamCreator;
/**
 * DatasetsInternalApi - functional programming interface
 * @export
 */
const DatasetsInternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetsInternalApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @param {ActiveLinksQueryData} [activeLinksQueryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsActiveLinksPost(activeLinksQueryData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsActiveLinksPost(activeLinksQueryData, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinkIdentifiersGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsLinkIdentifiersGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinksDeleteLinkIdDelete(linkId, schemeId, schemeItemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsLinksDeleteLinkIdDelete(linkId, schemeId, schemeItemId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinksGet(schemeId, schemeItemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsLinksGet(schemeId, schemeItemId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @param {SchemeItemDatasetLinkHolder} [schemeItemDatasetLinkHolder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSavePost(schemeItemDatasetLinkHolder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsSavePost(schemeItemDatasetLinkHolder, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsUpdateLinkPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsUpdateLinkPost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DatasetsInternalApiFp = DatasetsInternalApiFp;
/**
 * DatasetsInternalApi - factory interface
 * @export
 */
const DatasetsInternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetsInternalApiFp)(configuration);
    return {
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @param {ActiveLinksQueryData} [activeLinksQueryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsActiveLinksPost(activeLinksQueryData, options) {
            return localVarFp.datasetsActiveLinksPost(activeLinksQueryData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinkIdentifiersGet(options) {
            return localVarFp.datasetsLinkIdentifiersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinksDeleteLinkIdDelete(linkId, schemeId, schemeItemId, options) {
            return localVarFp.datasetsLinksDeleteLinkIdDelete(linkId, schemeId, schemeItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsLinksGet(schemeId, schemeItemId, options) {
            return localVarFp.datasetsLinksGet(schemeId, schemeItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @param {SchemeItemDatasetLinkHolder} [schemeItemDatasetLinkHolder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsSavePost(schemeItemDatasetLinkHolder, options) {
            return localVarFp.datasetsSavePost(schemeItemDatasetLinkHolder, options).then((request) => request(axios, basePath));
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsUpdateLinkPost(body, options) {
            return localVarFp.datasetsUpdateLinkPost(body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetsInternalApiFactory = DatasetsInternalApiFactory;
/**
 * DatasetsInternalApi - object-oriented interface
 * @export
 * @class DatasetsInternalApi
 * @extends {BaseAPI}
 */
class DatasetsInternalApi extends base_1.BaseAPI {
    /**
     * Get dataset links that are assigned to given EA-PSM scheme items
     * @param {ActiveLinksQueryData} [activeLinksQueryData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetsActiveLinksPost(activeLinksQueryData, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetsActiveLinksPost(activeLinksQueryData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetsLinkIdentifiersGet(options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetsLinkIdentifiersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete single dataset link from EA-PSM scheme item
     * @param {number} linkId Dataset link object to delete
     * @param {string} schemeId EA-PSM scheme UUID
     * @param {string} schemeItemId EA-PSM scheme item UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetsLinksDeleteLinkIdDelete(linkId, schemeId, schemeItemId, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetsLinksDeleteLinkIdDelete(linkId, schemeId, schemeItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset links that are assigned to given EA-PSM scheme item
     * @param {string} schemeId EA-PSM scheme UUID
     * @param {string} schemeItemId EA-PSM scheme item UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetsLinksGet(schemeId, schemeItemId, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetsLinksGet(schemeId, schemeItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Save EA-PSM scheme item dataset link holder to the database
     * @param {SchemeItemDatasetLinkHolder} [schemeItemDatasetLinkHolder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetsSavePost(schemeItemDatasetLinkHolder, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetsSavePost(schemeItemDatasetLinkHolder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Save EA-PSM scheme item single dataset link to the database
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetsUpdateLinkPost(body, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetsUpdateLinkPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetsInternalApi = DatasetsInternalApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {UpdateProductEntriesRequest} [updateProductEntriesRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        aDataPost: (updateProductEntriesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/{a}/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateProductEntriesRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get data for bubble/scatter chart
         * @param {number} id
         * @param {string} [colorAttr]
         * @param {number} [nCount]
         * @param {string} [xAttr]
         * @param {string} [yAttr]
         * @param {string} [zAttr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIdBubbleDataGet: (id, colorAttr, nCount, xAttr, yAttr, zAttr, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('aIdBubbleDataGet', 'id', id);
            const localVarPath = `/{a}/{id}/bubbleData`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (colorAttr !== undefined) {
                localVarQueryParameter['colorAttr'] = colorAttr;
            }
            if (nCount !== undefined) {
                localVarQueryParameter['nCount'] = nCount;
            }
            if (xAttr !== undefined) {
                localVarQueryParameter['xAttr'] = xAttr;
            }
            if (yAttr !== undefined) {
                localVarQueryParameter['yAttr'] = yAttr;
            }
            if (zAttr !== undefined) {
                localVarQueryParameter['zAttr'] = zAttr;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aInfosGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/{a}/infos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aInfosIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('aInfosIdGet', 'id', id);
            const localVarPath = `/{a}/infos/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefAsForeignKeysGet: (productTemplateRef, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefAsForeignKeysGet', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/asForeignKeys`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDataGet: (productTemplateRef, dateFrom, dateTo, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefDataGet', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDataPost: (productTemplateRef, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefDataPost', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/data`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDeleteByFilterDelete: (productTemplateRef, dateFrom, dateTo, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefDeleteByFilterDelete', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/delete-by-filter`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString() :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString() :
                    dateTo;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} attribute
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdAttributeSignPut: (attribute, entryId, productTemplateRef, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'attribute' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdAttributeSignPut', 'attribute', attribute);
            // verify required parameter 'entryId' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdAttributeSignPut', 'entryId', entryId);
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdAttributeSignPut', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/{entryId}/{attribute}/sign`
                .replace(`{${"attribute"}}`, encodeURIComponent(String(attribute)))
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdDelete: (entryId, productTemplateRef, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entryId' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdDelete', 'entryId', entryId);
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdDelete', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdPatch: (entryId, productTemplateRef, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entryId' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdPatch', 'entryId', entryId);
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefEntryIdPatch', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/{entryId}`
                .replace(`{${"entryId"}}`, encodeURIComponent(String(entryId)))
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefFilterPreviewGet: (productTemplateRef, dateFrom, dateTo, filter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefFilterPreviewGet', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/filter-preview`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom instanceof Date) ?
                    dateFrom.toISOString() :
                    dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo instanceof Date) ?
                    dateTo.toISOString() :
                    dateTo;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefWipeAllDelete: (productTemplateRef, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productTemplateRef' is not null or undefined
            (0, common_1.assertParamExists)('aProductTemplateRefWipeAllDelete', 'productTemplateRef', productTemplateRef);
            const localVarPath = `/{a}/{productTemplateRef}/wipe-all`
                .replace(`{${"productTemplateRef"}}`, encodeURIComponent(String(productTemplateRef)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aRefIdGet: (ref, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ref' is not null or undefined
            (0, common_1.assertParamExists)('aRefIdGet', 'ref', ref);
            const localVarPath = `/{a}/{ref}/id`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aUpdateDataBatchPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/{a}/update-data-batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdGraphLinkGet: (dagId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdGraphLinkGet', 'dagId', dagId);
            const localVarPath = `/airflow/dag/{dagId}/graph-link`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdGetJobDataPost: (dagId, taskId, calcPeriod, calcTimestamp, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskIdGetJobDataPost', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskIdGetJobDataPost', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/getJobData`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (calcPeriod !== undefined) {
                localVarQueryParameter['calcPeriod'] = calcPeriod;
            }
            if (calcTimestamp !== undefined) {
                localVarQueryParameter['calcTimestamp'] = calcTimestamp;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdJobConfigGet: (dagId, taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskIdJobConfigGet', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskIdJobConfigGet', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/jobConfig`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdPostJobDataPost: (dagId, taskId, calcPeriod, calcTimestamp, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskIdPostJobDataPost', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskIdPostJobDataPost', 'taskId', taskId);
            const localVarPath = `/airflow/dag/{dagId}/{taskId}/postJobData`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (calcPeriod !== undefined) {
                localVarQueryParameter['calcPeriod'] = calcPeriod;
            }
            if (calcTimestamp !== undefined) {
                localVarQueryParameter['calcTimestamp'] = calcTimestamp;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskInfosGet: (dagId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('airflowDagDagIdTaskInfosGet', 'dagId', dagId);
            const localVarPath = `/airflow/dag/{dagId}/task-infos`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [categoryId]
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsPushPost: (categoryId, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/datasets/push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} uploadedFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesUploadedFileIdGet: (uploadedFileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uploadedFileId' is not null or undefined
            (0, common_1.assertParamExists)('imagesUploadedFileIdGet', 'uploadedFileId', uploadedFileId);
            const localVarPath = `/images/{uploadedFileId}`
                .replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(uploadedFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [includeDatasets]
         * @param {Array<number>} [tagObjectIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesDevicesByTagsGet: (includeDatasets, tagObjectIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/measurementDevices/devicesByTags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeDatasets !== undefined) {
                localVarQueryParameter['includeDatasets'] = includeDatasets;
            }
            if (tagObjectIds) {
                localVarQueryParameter['tagObjectIds'] = tagObjectIds;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesGeoMeasurementDevicesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/measurementDevices/geoMeasurementDevices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [deviceIds]
         * @param {string} [topic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesMeasurementDevicesReadingsByTopicGet: (deviceIds, topic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/measurementDevices/measurementDevicesReadingsByTopic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (deviceIds !== undefined) {
                localVarQueryParameter['deviceIds'] = deviceIds;
            }
            if (topic !== undefined) {
                localVarQueryParameter['topic'] = topic;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsMigrationIdPost: (migrationId, dryRun, requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'migrationId' is not null or undefined
            (0, common_1.assertParamExists)('migrationsMigrationIdPost', 'migrationId', migrationId);
            const localVarPath = `/migrations/{migrationId}`
                .replace(`{${"migrationId"}}`, encodeURIComponent(String(migrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dryRun !== undefined) {
                localVarQueryParameter['dry-run'] = dryRun;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [run]
         * @param {ScheduledTaskDTO} [scheduledTaskDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowConfigPost: (run, scheduledTaskDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/scheduled-tasks/airflow/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (run !== undefined) {
                localVarQueryParameter['run'] = run;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduledTaskDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdConfigGet: (dagId, taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksAirflowDagIdTaskIdConfigGet', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksAirflowDagIdTaskIdConfigGet', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/config`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdHistoriesGet: (dagId, taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksAirflowDagIdTaskIdHistoriesGet', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksAirflowDagIdTaskIdHistoriesGet', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/histories`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdTestDataGet: (dagId, taskId, referenceTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dagId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksAirflowDagIdTaskIdTestDataGet', 'dagId', dagId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('scheduledTasksAirflowDagIdTaskIdTestDataGet', 'taskId', taskId);
            const localVarPath = `/scheduled-tasks/airflow/{dagId}/{taskId}/test-data`
                .replace(`{${"dagId"}}`, encodeURIComponent(String(dagId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (referenceTime !== undefined) {
                localVarQueryParameter['referenceTime'] = referenceTime;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksCodeUploadPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/scheduled-tasks/code/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksTemplatesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/scheduled-tasks/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksTestyGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/scheduled-tasks/testy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {UpdateProductEntriesRequest} [updateProductEntriesRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        aDataPost(updateProductEntriesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aDataPost(updateProductEntriesRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get data for bubble/scatter chart
         * @param {number} id
         * @param {string} [colorAttr]
         * @param {number} [nCount]
         * @param {string} [xAttr]
         * @param {string} [yAttr]
         * @param {string} [zAttr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIdBubbleDataGet(id, colorAttr, nCount, xAttr, yAttr, zAttr, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aIdBubbleDataGet(id, colorAttr, nCount, xAttr, yAttr, zAttr, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aInfosGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aInfosGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aInfosIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aInfosIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefAsForeignKeysGet(productTemplateRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefAsForeignKeysGet(productTemplateRef, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDataPost(productTemplateRef, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefDataPost(productTemplateRef, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} attribute
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdAttributeSignPut(attribute, entryId, productTemplateRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefEntryIdAttributeSignPut(attribute, entryId, productTemplateRef, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdDelete(entryId, productTemplateRef, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefEntryIdDelete(entryId, productTemplateRef, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdPatch(entryId, productTemplateRef, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefEntryIdPatch(entryId, productTemplateRef, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefFilterPreviewGet(productTemplateRef, dateFrom, dateTo, filter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefFilterPreviewGet(productTemplateRef, dateFrom, dateTo, filter, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefWipeAllDelete(productTemplateRef, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aProductTemplateRefWipeAllDelete(productTemplateRef, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aRefIdGet(ref, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aRefIdGet(ref, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aUpdateDataBatchPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.aUpdateDataBatchPost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdGraphLinkGet(dagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowDagDagIdGraphLinkGet(dagId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdGetJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowDagDagIdTaskIdGetJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdJobConfigGet(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowDagDagIdTaskIdJobConfigGet(dagId, taskId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdPostJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowDagDagIdTaskIdPostJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskInfosGet(dagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.airflowDagDagIdTaskInfosGet(dagId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsPushPost(categoryId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetsPushPost(categoryId, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} uploadedFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesUploadedFileIdGet(uploadedFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.imagesUploadedFileIdGet(uploadedFileId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [includeDatasets]
         * @param {Array<number>} [tagObjectIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesDevicesByTagsGet(includeDatasets, tagObjectIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.measurementDevicesDevicesByTagsGet(includeDatasets, tagObjectIds, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesGeoMeasurementDevicesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.measurementDevicesGeoMeasurementDevicesGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [deviceIds]
         * @param {string} [topic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesMeasurementDevicesReadingsByTopicGet(deviceIds, topic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.measurementDevicesMeasurementDevicesReadingsByTopicGet(deviceIds, topic, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsMigrationIdPost(migrationId, dryRun, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationsMigrationIdPost(migrationId, dryRun, requestBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [run]
         * @param {ScheduledTaskDTO} [scheduledTaskDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowConfigPost(run, scheduledTaskDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksAirflowConfigPost(run, scheduledTaskDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdConfigGet(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksAirflowDagIdTaskIdConfigGet(dagId, taskId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdHistoriesGet(dagId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksAirflowDagIdTaskIdHistoriesGet(dagId, taskId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdTestDataGet(dagId, taskId, referenceTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksAirflowDagIdTaskIdTestDataGet(dagId, taskId, referenceTime, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksCodeUploadPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksCodeUploadPost(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksTemplatesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksTemplatesGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksTestyGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduledTasksTestyGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @param {UpdateProductEntriesRequest} [updateProductEntriesRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        aDataPost(updateProductEntriesRequest, options) {
            return localVarFp.aDataPost(updateProductEntriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get data for bubble/scatter chart
         * @param {number} id
         * @param {string} [colorAttr]
         * @param {number} [nCount]
         * @param {string} [xAttr]
         * @param {string} [yAttr]
         * @param {string} [zAttr]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aIdBubbleDataGet(id, colorAttr, nCount, xAttr, yAttr, zAttr, options) {
            return localVarFp.aIdBubbleDataGet(id, colorAttr, nCount, xAttr, yAttr, zAttr, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aInfosGet(options) {
            return localVarFp.aInfosGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aInfosIdGet(id, options) {
            return localVarFp.aInfosIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefAsForeignKeysGet(productTemplateRef, options) {
            return localVarFp.aProductTemplateRefAsForeignKeysGet(productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options) {
            return localVarFp.aProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDataPost(productTemplateRef, requestBody, options) {
            return localVarFp.aProductTemplateRefDataPost(productTemplateRef, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options) {
            return localVarFp.aProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} attribute
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdAttributeSignPut(attribute, entryId, productTemplateRef, options) {
            return localVarFp.aProductTemplateRefEntryIdAttributeSignPut(attribute, entryId, productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdDelete(entryId, productTemplateRef, requestBody, options) {
            return localVarFp.aProductTemplateRefEntryIdDelete(entryId, productTemplateRef, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} entryId
         * @param {string} productTemplateRef
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefEntryIdPatch(entryId, productTemplateRef, requestBody, options) {
            return localVarFp.aProductTemplateRefEntryIdPatch(entryId, productTemplateRef, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {string} [dateFrom]
         * @param {string} [dateTo]
         * @param {string} [filter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefFilterPreviewGet(productTemplateRef, dateFrom, dateTo, filter, options) {
            return localVarFp.aProductTemplateRefFilterPreviewGet(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} productTemplateRef
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aProductTemplateRefWipeAllDelete(productTemplateRef, options) {
            return localVarFp.aProductTemplateRefWipeAllDelete(productTemplateRef, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} ref
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aRefIdGet(ref, options) {
            return localVarFp.aRefIdGet(ref, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aUpdateDataBatchPost(body, options) {
            return localVarFp.aUpdateDataBatchPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdGraphLinkGet(dagId, options) {
            return localVarFp.airflowDagDagIdGraphLinkGet(dagId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdGetJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options) {
            return localVarFp.airflowDagDagIdTaskIdGetJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdJobConfigGet(dagId, taskId, options) {
            return localVarFp.airflowDagDagIdTaskIdJobConfigGet(dagId, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {number} [calcPeriod]
         * @param {number} [calcTimestamp]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskIdPostJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options) {
            return localVarFp.airflowDagDagIdTaskIdPostJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        airflowDagDagIdTaskInfosGet(dagId, options) {
            return localVarFp.airflowDagDagIdTaskInfosGet(dagId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetsPushPost(categoryId, requestBody, options) {
            return localVarFp.datasetsPushPost(categoryId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} uploadedFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        imagesUploadedFileIdGet(uploadedFileId, options) {
            return localVarFp.imagesUploadedFileIdGet(uploadedFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [includeDatasets]
         * @param {Array<number>} [tagObjectIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesDevicesByTagsGet(includeDatasets, tagObjectIds, options) {
            return localVarFp.measurementDevicesDevicesByTagsGet(includeDatasets, tagObjectIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesGeoMeasurementDevicesGet(options) {
            return localVarFp.measurementDevicesGeoMeasurementDevicesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [deviceIds]
         * @param {string} [topic]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        measurementDevicesMeasurementDevicesReadingsByTopicGet(deviceIds, topic, options) {
            return localVarFp.measurementDevicesMeasurementDevicesReadingsByTopicGet(deviceIds, topic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} migrationId
         * @param {boolean} [dryRun]
         * @param {{ [key: string]: string; }} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationsMigrationIdPost(migrationId, dryRun, requestBody, options) {
            return localVarFp.migrationsMigrationIdPost(migrationId, dryRun, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [run]
         * @param {ScheduledTaskDTO} [scheduledTaskDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowConfigPost(run, scheduledTaskDTO, options) {
            return localVarFp.scheduledTasksAirflowConfigPost(run, scheduledTaskDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdConfigGet(dagId, taskId, options) {
            return localVarFp.scheduledTasksAirflowDagIdTaskIdConfigGet(dagId, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdHistoriesGet(dagId, taskId, options) {
            return localVarFp.scheduledTasksAirflowDagIdTaskIdHistoriesGet(dagId, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dagId
         * @param {string} taskId
         * @param {string} [referenceTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksAirflowDagIdTaskIdTestDataGet(dagId, taskId, referenceTime, options) {
            return localVarFp.scheduledTasksAirflowDagIdTaskIdTestDataGet(dagId, taskId, referenceTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksCodeUploadPost(options) {
            return localVarFp.scheduledTasksCodeUploadPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksTemplatesGet(options) {
            return localVarFp.scheduledTasksTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledTasksTestyGet(options) {
            return localVarFp.scheduledTasksTestyGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @param {UpdateProductEntriesRequest} [updateProductEntriesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aDataPost(updateProductEntriesRequest, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aDataPost(updateProductEntriesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get data for bubble/scatter chart
     * @param {number} id
     * @param {string} [colorAttr]
     * @param {number} [nCount]
     * @param {string} [xAttr]
     * @param {string} [yAttr]
     * @param {string} [zAttr]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aIdBubbleDataGet(id, colorAttr, nCount, xAttr, yAttr, zAttr, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aIdBubbleDataGet(id, colorAttr, nCount, xAttr, yAttr, zAttr, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aInfosGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).aInfosGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aInfosIdGet(id, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aInfosIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productTemplateRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefAsForeignKeysGet(productTemplateRef, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefAsForeignKeysGet(productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productTemplateRef
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefDataGet(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productTemplateRef
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefDataPost(productTemplateRef, requestBody, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefDataPost(productTemplateRef, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productTemplateRef
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefDeleteByFilterDelete(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} attribute
     * @param {string} entryId
     * @param {string} productTemplateRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefEntryIdAttributeSignPut(attribute, entryId, productTemplateRef, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefEntryIdAttributeSignPut(attribute, entryId, productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} entryId
     * @param {string} productTemplateRef
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefEntryIdDelete(entryId, productTemplateRef, requestBody, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefEntryIdDelete(entryId, productTemplateRef, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} entryId
     * @param {string} productTemplateRef
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefEntryIdPatch(entryId, productTemplateRef, requestBody, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefEntryIdPatch(entryId, productTemplateRef, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productTemplateRef
     * @param {string} [dateFrom]
     * @param {string} [dateTo]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefFilterPreviewGet(productTemplateRef, dateFrom, dateTo, filter, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefFilterPreviewGet(productTemplateRef, dateFrom, dateTo, filter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} productTemplateRef
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aProductTemplateRefWipeAllDelete(productTemplateRef, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aProductTemplateRefWipeAllDelete(productTemplateRef, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} ref
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aRefIdGet(ref, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aRefIdGet(ref, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    aUpdateDataBatchPost(body, options) {
        return (0, exports.DefaultApiFp)(this.configuration).aUpdateDataBatchPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    airflowDagDagIdGraphLinkGet(dagId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).airflowDagDagIdGraphLinkGet(dagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {string} taskId
     * @param {number} [calcPeriod]
     * @param {number} [calcTimestamp]
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    airflowDagDagIdTaskIdGetJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options) {
        return (0, exports.DefaultApiFp)(this.configuration).airflowDagDagIdTaskIdGetJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {string} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    airflowDagDagIdTaskIdJobConfigGet(dagId, taskId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).airflowDagDagIdTaskIdJobConfigGet(dagId, taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {string} taskId
     * @param {number} [calcPeriod]
     * @param {number} [calcTimestamp]
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    airflowDagDagIdTaskIdPostJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options) {
        return (0, exports.DefaultApiFp)(this.configuration).airflowDagDagIdTaskIdPostJobDataPost(dagId, taskId, calcPeriod, calcTimestamp, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    airflowDagDagIdTaskInfosGet(dagId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).airflowDagDagIdTaskInfosGet(dagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [categoryId]
     * @param {Array<any>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    datasetsPushPost(categoryId, requestBody, options) {
        return (0, exports.DefaultApiFp)(this.configuration).datasetsPushPost(categoryId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} uploadedFileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    imagesUploadedFileIdGet(uploadedFileId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).imagesUploadedFileIdGet(uploadedFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [includeDatasets]
     * @param {Array<number>} [tagObjectIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    measurementDevicesDevicesByTagsGet(includeDatasets, tagObjectIds, options) {
        return (0, exports.DefaultApiFp)(this.configuration).measurementDevicesDevicesByTagsGet(includeDatasets, tagObjectIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    measurementDevicesGeoMeasurementDevicesGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).measurementDevicesGeoMeasurementDevicesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [deviceIds]
     * @param {string} [topic]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    measurementDevicesMeasurementDevicesReadingsByTopicGet(deviceIds, topic, options) {
        return (0, exports.DefaultApiFp)(this.configuration).measurementDevicesMeasurementDevicesReadingsByTopicGet(deviceIds, topic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} migrationId
     * @param {boolean} [dryRun]
     * @param {{ [key: string]: string; }} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    migrationsMigrationIdPost(migrationId, dryRun, requestBody, options) {
        return (0, exports.DefaultApiFp)(this.configuration).migrationsMigrationIdPost(migrationId, dryRun, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [run]
     * @param {ScheduledTaskDTO} [scheduledTaskDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksAirflowConfigPost(run, scheduledTaskDTO, options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksAirflowConfigPost(run, scheduledTaskDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {string} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksAirflowDagIdTaskIdConfigGet(dagId, taskId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksAirflowDagIdTaskIdConfigGet(dagId, taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {string} taskId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksAirflowDagIdTaskIdHistoriesGet(dagId, taskId, options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksAirflowDagIdTaskIdHistoriesGet(dagId, taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} dagId
     * @param {string} taskId
     * @param {string} [referenceTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksAirflowDagIdTaskIdTestDataGet(dagId, taskId, referenceTime, options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksAirflowDagIdTaskIdTestDataGet(dagId, taskId, referenceTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksCodeUploadPost(options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksCodeUploadPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksTemplatesGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    scheduledTasksTestyGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).scheduledTasksTestyGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * GoogleAuthorizationApi - axios parameter creator
 * @export
 */
const GoogleAuthorizationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleStoreCalendarGet: (code, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/google/store/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.GoogleAuthorizationApiAxiosParamCreator = GoogleAuthorizationApiAxiosParamCreator;
/**
 * GoogleAuthorizationApi - functional programming interface
 * @export
 */
const GoogleAuthorizationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GoogleAuthorizationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleStoreCalendarGet(code, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.googleStoreCalendarGet(code, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.GoogleAuthorizationApiFp = GoogleAuthorizationApiFp;
/**
 * GoogleAuthorizationApi - factory interface
 * @export
 */
const GoogleAuthorizationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GoogleAuthorizationApiFp)(configuration);
    return {
        /**
         *
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleStoreCalendarGet(code, options) {
            return localVarFp.googleStoreCalendarGet(code, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GoogleAuthorizationApiFactory = GoogleAuthorizationApiFactory;
/**
 * GoogleAuthorizationApi - object-oriented interface
 * @export
 * @class GoogleAuthorizationApi
 * @extends {BaseAPI}
 */
class GoogleAuthorizationApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoogleAuthorizationApi
     */
    googleStoreCalendarGet(code, options) {
        return (0, exports.GoogleAuthorizationApiFp)(this.configuration).googleStoreCalendarGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GoogleAuthorizationApi = GoogleAuthorizationApi;
/**
 * HydraulicPipeDataApi - axios parameter creator
 * @export
 */
const HydraulicPipeDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get hydraulic pipe layout data based on provided element unique ID\'s.
         * @param {GetItemDataByUniqueIDsRequestParameters} [getItemDataByUniqueIDsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydraulicitemdataPipeLayoutDataByUniqueIDsPost: (getItemDataByUniqueIDsRequestParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/hydraulicitemdata/pipeLayoutDataByUniqueIDs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemDataByUniqueIDsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.HydraulicPipeDataApiAxiosParamCreator = HydraulicPipeDataApiAxiosParamCreator;
/**
 * HydraulicPipeDataApi - functional programming interface
 * @export
 */
const HydraulicPipeDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.HydraulicPipeDataApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get hydraulic pipe layout data based on provided element unique ID\'s.
         * @param {GetItemDataByUniqueIDsRequestParameters} [getItemDataByUniqueIDsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydraulicitemdataPipeLayoutDataByUniqueIDsPost(getItemDataByUniqueIDsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hydraulicitemdataPipeLayoutDataByUniqueIDsPost(getItemDataByUniqueIDsRequestParameters, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.HydraulicPipeDataApiFp = HydraulicPipeDataApiFp;
/**
 * HydraulicPipeDataApi - factory interface
 * @export
 */
const HydraulicPipeDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.HydraulicPipeDataApiFp)(configuration);
    return {
        /**
         * Get hydraulic pipe layout data based on provided element unique ID\'s.
         * @param {GetItemDataByUniqueIDsRequestParameters} [getItemDataByUniqueIDsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hydraulicitemdataPipeLayoutDataByUniqueIDsPost(getItemDataByUniqueIDsRequestParameters, options) {
            return localVarFp.hydraulicitemdataPipeLayoutDataByUniqueIDsPost(getItemDataByUniqueIDsRequestParameters, options).then((request) => request(axios, basePath));
        },
    };
};
exports.HydraulicPipeDataApiFactory = HydraulicPipeDataApiFactory;
/**
 * HydraulicPipeDataApi - object-oriented interface
 * @export
 * @class HydraulicPipeDataApi
 * @extends {BaseAPI}
 */
class HydraulicPipeDataApi extends base_1.BaseAPI {
    /**
     * Get hydraulic pipe layout data based on provided element unique ID\'s.
     * @param {GetItemDataByUniqueIDsRequestParameters} [getItemDataByUniqueIDsRequestParameters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HydraulicPipeDataApi
     */
    hydraulicitemdataPipeLayoutDataByUniqueIDsPost(getItemDataByUniqueIDsRequestParameters, options) {
        return (0, exports.HydraulicPipeDataApiFp)(this.configuration).hydraulicitemdataPipeLayoutDataByUniqueIDsPost(getItemDataByUniqueIDsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.HydraulicPipeDataApi = HydraulicPipeDataApi;
/**
 * JWTApi - axios parameter creator
 * @export
 */
const JWTApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtAGet: (ttl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/jwt/{a}`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} user
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtAdminTokenUserGet: (user, ttl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'user' is not null or undefined
            (0, common_1.assertParamExists)('jwtAdminTokenUserGet', 'user', user);
            const localVarPath = `/jwt/adminToken/{user}`
                .replace(`{${"user"}}`, encodeURIComponent(String(user)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtPublicKeyGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/jwt/publicKey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtPublicKeyKeyIdGet: (keyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'keyId' is not null or undefined
            (0, common_1.assertParamExists)('jwtPublicKeyKeyIdGet', 'keyId', keyId);
            const localVarPath = `/jwt/publicKey/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtTokenGooglePost: (ttl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/jwt/tokenGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (ttl !== undefined) {
                localVarQueryParameter['ttl'] = ttl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtValidKeysGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/jwt/validKeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.JWTApiAxiosParamCreator = JWTApiAxiosParamCreator;
/**
 * JWTApi - functional programming interface
 * @export
 */
const JWTApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.JWTApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtAGet(ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtAGet(ttl, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} user
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtAdminTokenUserGet(user, ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtAdminTokenUserGet(user, ttl, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtPublicKeyGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtPublicKeyGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtPublicKeyKeyIdGet(keyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtPublicKeyKeyIdGet(keyId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtTokenGooglePost(ttl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtTokenGooglePost(ttl, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtValidKeysGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.jwtValidKeysGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.JWTApiFp = JWTApiFp;
/**
 * JWTApi - factory interface
 * @export
 */
const JWTApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.JWTApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtAGet(ttl, options) {
            return localVarFp.jwtAGet(ttl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} user
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtAdminTokenUserGet(user, ttl, options) {
            return localVarFp.jwtAdminTokenUserGet(user, ttl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtPublicKeyGet(options) {
            return localVarFp.jwtPublicKeyGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} keyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtPublicKeyKeyIdGet(keyId, options) {
            return localVarFp.jwtPublicKeyKeyIdGet(keyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [ttl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtTokenGooglePost(ttl, options) {
            return localVarFp.jwtTokenGooglePost(ttl, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jwtValidKeysGet(options) {
            return localVarFp.jwtValidKeysGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.JWTApiFactory = JWTApiFactory;
/**
 * JWTApi - object-oriented interface
 * @export
 * @class JWTApi
 * @extends {BaseAPI}
 */
class JWTApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [ttl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtAGet(ttl, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtAGet(ttl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} user
     * @param {number} [ttl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtAdminTokenUserGet(user, ttl, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtAdminTokenUserGet(user, ttl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtPublicKeyGet(options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtPublicKeyGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} keyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtPublicKeyKeyIdGet(keyId, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtPublicKeyKeyIdGet(keyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [ttl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtTokenGooglePost(ttl, options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtTokenGooglePost(ttl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JWTApi
     */
    jwtValidKeysGet(options) {
        return (0, exports.JWTApiFp)(this.configuration).jwtValidKeysGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JWTApi = JWTApi;
/**
 * LicenceApi - axios parameter creator
 * @export
 */
const LicenceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesActivateKeyKeyGet: (key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            (0, common_1.assertParamExists)('licencesActivateKeyKeyGet', 'key', key);
            const localVarPath = `/licences/activateKey/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesActivateProductKeyGet: (key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            (0, common_1.assertParamExists)('licencesActivateProductKeyGet', 'key', key);
            const localVarPath = `/licences/activateProduct/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesKeyInfoKeyGet: (key, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'key' is not null or undefined
            (0, common_1.assertParamExists)('licencesKeyInfoKeyGet', 'key', key);
            const localVarPath = `/licences/keyInfo/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesLicenceInfoGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/licences/licenceInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesLicencesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/licences/licences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [activeOnly]
         * @param {Array<string>} [product]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesProductsGet: (activeOnly, product, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/licences/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }
            if (product) {
                localVarQueryParameter['product'] = product;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} userId
         * @param {number} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesSetUserLicenceUserIdPost: (userId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('licencesSetUserLicenceUserIdPost', 'userId', userId);
            const localVarPath = `/licences/setUserLicence/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.LicenceApiAxiosParamCreator = LicenceApiAxiosParamCreator;
/**
 * LicenceApi - functional programming interface
 * @export
 */
const LicenceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.LicenceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesActivateKeyKeyGet(key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesActivateKeyKeyGet(key, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesActivateProductKeyGet(key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesActivateProductKeyGet(key, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesKeyInfoKeyGet(key, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesKeyInfoKeyGet(key, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesLicenceInfoGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesLicenceInfoGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesLicencesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesLicencesGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [activeOnly]
         * @param {Array<string>} [product]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesProductsGet(activeOnly, product, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesProductsGet(activeOnly, product, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} userId
         * @param {number} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesSetUserLicenceUserIdPost(userId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.licencesSetUserLicenceUserIdPost(userId, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.LicenceApiFp = LicenceApiFp;
/**
 * LicenceApi - factory interface
 * @export
 */
const LicenceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.LicenceApiFp)(configuration);
    return {
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesActivateKeyKeyGet(key, options) {
            return localVarFp.licencesActivateKeyKeyGet(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesActivateProductKeyGet(key, options) {
            return localVarFp.licencesActivateProductKeyGet(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesKeyInfoKeyGet(key, options) {
            return localVarFp.licencesKeyInfoKeyGet(key, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesLicenceInfoGet(options) {
            return localVarFp.licencesLicenceInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesLicencesGet(options) {
            return localVarFp.licencesLicencesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [activeOnly]
         * @param {Array<string>} [product]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesProductsGet(activeOnly, product, options) {
            return localVarFp.licencesProductsGet(activeOnly, product, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} userId
         * @param {number} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licencesSetUserLicenceUserIdPost(userId, body, options) {
            return localVarFp.licencesSetUserLicenceUserIdPost(userId, body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.LicenceApiFactory = LicenceApiFactory;
/**
 * LicenceApi - object-oriented interface
 * @export
 * @class LicenceApi
 * @extends {BaseAPI}
 */
class LicenceApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesActivateKeyKeyGet(key, options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesActivateKeyKeyGet(key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesActivateProductKeyGet(key, options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesActivateProductKeyGet(key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesKeyInfoKeyGet(key, options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesKeyInfoKeyGet(key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesLicenceInfoGet(options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesLicenceInfoGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesLicencesGet(options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesLicencesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [activeOnly]
     * @param {Array<string>} [product]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesProductsGet(activeOnly, product, options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesProductsGet(activeOnly, product, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} userId
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LicenceApi
     */
    licencesSetUserLicenceUserIdPost(userId, body, options) {
        return (0, exports.LicenceApiFp)(this.configuration).licencesSetUserLicenceUserIdPost(userId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LicenceApi = LicenceApi;
/**
 * MigrationHelperApi - axios parameter creator
 * @export
 */
const MigrationHelperApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [companyId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperConvertCompanyIdToCompanyReferenceGet: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/migrationHelper/convertCompanyIdToCompanyReference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperConvertCompanyReferenceToCompanyIdGet: (companyReference, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/migrationHelper/convertCompanyReferenceToCompanyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyReference !== undefined) {
                localVarQueryParameter['companyReference'] = companyReference;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperKnownCompanyReferenceMappingsMappingsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/migrationHelper/knownCompanyReferenceMappingsMappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MigrationHelperApiAxiosParamCreator = MigrationHelperApiAxiosParamCreator;
/**
 * MigrationHelperApi - functional programming interface
 * @export
 */
const MigrationHelperApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MigrationHelperApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [companyId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperConvertCompanyIdToCompanyReferenceGet(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationHelperConvertCompanyIdToCompanyReferenceGet(companyId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperConvertCompanyReferenceToCompanyIdGet(companyReference, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationHelperConvertCompanyReferenceToCompanyIdGet(companyReference, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperKnownCompanyReferenceMappingsMappingsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.migrationHelperKnownCompanyReferenceMappingsMappingsGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.MigrationHelperApiFp = MigrationHelperApiFp;
/**
 * MigrationHelperApi - factory interface
 * @export
 */
const MigrationHelperApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MigrationHelperApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [companyId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperConvertCompanyIdToCompanyReferenceGet(companyId, options) {
            return localVarFp.migrationHelperConvertCompanyIdToCompanyReferenceGet(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyReference]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperConvertCompanyReferenceToCompanyIdGet(companyReference, options) {
            return localVarFp.migrationHelperConvertCompanyReferenceToCompanyIdGet(companyReference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrationHelperKnownCompanyReferenceMappingsMappingsGet(options) {
            return localVarFp.migrationHelperKnownCompanyReferenceMappingsMappingsGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.MigrationHelperApiFactory = MigrationHelperApiFactory;
/**
 * MigrationHelperApi - object-oriented interface
 * @export
 * @class MigrationHelperApi
 * @extends {BaseAPI}
 */
class MigrationHelperApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [companyId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationHelperApi
     */
    migrationHelperConvertCompanyIdToCompanyReferenceGet(companyId, options) {
        return (0, exports.MigrationHelperApiFp)(this.configuration).migrationHelperConvertCompanyIdToCompanyReferenceGet(companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [companyReference]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationHelperApi
     */
    migrationHelperConvertCompanyReferenceToCompanyIdGet(companyReference, options) {
        return (0, exports.MigrationHelperApiFp)(this.configuration).migrationHelperConvertCompanyReferenceToCompanyIdGet(companyReference, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationHelperApi
     */
    migrationHelperKnownCompanyReferenceMappingsMappingsGet(options) {
        return (0, exports.MigrationHelperApiFp)(this.configuration).migrationHelperKnownCompanyReferenceMappingsMappingsGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MigrationHelperApi = MigrationHelperApi;
/**
 * ReservationApi - axios parameter creator
 * @export
 */
const ReservationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get previously reserved scheme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemedeliveryReservedGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemedelivery/reserved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ReservationApiAxiosParamCreator = ReservationApiAxiosParamCreator;
/**
 * ReservationApi - functional programming interface
 * @export
 */
const ReservationApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ReservationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get previously reserved scheme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemedeliveryReservedGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemedeliveryReservedGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ReservationApiFp = ReservationApiFp;
/**
 * ReservationApi - factory interface
 * @export
 */
const ReservationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ReservationApiFp)(configuration);
    return {
        /**
         * Get previously reserved scheme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemedeliveryReservedGet(options) {
            return localVarFp.schemedeliveryReservedGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ReservationApiFactory = ReservationApiFactory;
/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
class ReservationApi extends base_1.BaseAPI {
    /**
     * Get previously reserved scheme
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    schemedeliveryReservedGet(options) {
        return (0, exports.ReservationApiFp)(this.configuration).schemedeliveryReservedGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ReservationApi = ReservationApi;
/**
 * SchemeApi - axios parameter creator
 * @export
 */
const SchemeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all schemes visible for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesAllSchemesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemes/allSchemes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get scheme near given SchemeItem
         * @param {string} itemId
         * @param {string} schemeId
         * @param {number} [margin]
         * @param {Set<RequestTagValue>} [requestTagValue]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesNearbySchemeIdItemIdPost: (itemId, schemeId, margin, requestTagValue, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('schemesNearbySchemeIdItemIdPost', 'itemId', itemId);
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemesNearbySchemeIdItemIdPost', 'schemeId', schemeId);
            const localVarPath = `/schemes/nearby/{schemeId}/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (margin !== undefined) {
                localVarQueryParameter['margin'] = margin;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestTagValue, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get scheme meta info
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesSchemeMetaSchemeIdGet: (schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemesSchemeMetaSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/schemes/schemeMeta/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SchemeApiAxiosParamCreator = SchemeApiAxiosParamCreator;
/**
 * SchemeApi - functional programming interface
 * @export
 */
const SchemeApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SchemeApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get all schemes visible for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesAllSchemesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemesAllSchemesGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get scheme near given SchemeItem
         * @param {string} itemId
         * @param {string} schemeId
         * @param {number} [margin]
         * @param {Set<RequestTagValue>} [requestTagValue]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesNearbySchemeIdItemIdPost(itemId, schemeId, margin, requestTagValue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemesNearbySchemeIdItemIdPost(itemId, schemeId, margin, requestTagValue, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get scheme meta info
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesSchemeMetaSchemeIdGet(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemesSchemeMetaSchemeIdGet(schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SchemeApiFp = SchemeApiFp;
/**
 * SchemeApi - factory interface
 * @export
 */
const SchemeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SchemeApiFp)(configuration);
    return {
        /**
         * Get all schemes visible for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesAllSchemesGet(options) {
            return localVarFp.schemesAllSchemesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get scheme near given SchemeItem
         * @param {string} itemId
         * @param {string} schemeId
         * @param {number} [margin]
         * @param {Set<RequestTagValue>} [requestTagValue]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesNearbySchemeIdItemIdPost(itemId, schemeId, margin, requestTagValue, options) {
            return localVarFp.schemesNearbySchemeIdItemIdPost(itemId, schemeId, margin, requestTagValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Get scheme meta info
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemesSchemeMetaSchemeIdGet(schemeId, options) {
            return localVarFp.schemesSchemeMetaSchemeIdGet(schemeId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SchemeApiFactory = SchemeApiFactory;
/**
 * SchemeApi - object-oriented interface
 * @export
 * @class SchemeApi
 * @extends {BaseAPI}
 */
class SchemeApi extends base_1.BaseAPI {
    /**
     * Get all schemes visible for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeApi
     */
    schemesAllSchemesGet(options) {
        return (0, exports.SchemeApiFp)(this.configuration).schemesAllSchemesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get scheme near given SchemeItem
     * @param {string} itemId
     * @param {string} schemeId
     * @param {number} [margin]
     * @param {Set<RequestTagValue>} [requestTagValue]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeApi
     */
    schemesNearbySchemeIdItemIdPost(itemId, schemeId, margin, requestTagValue, options) {
        return (0, exports.SchemeApiFp)(this.configuration).schemesNearbySchemeIdItemIdPost(itemId, schemeId, margin, requestTagValue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get scheme meta info
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeApi
     */
    schemesSchemeMetaSchemeIdGet(schemeId, options) {
        return (0, exports.SchemeApiFp)(this.configuration).schemesSchemeMetaSchemeIdGet(schemeId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SchemeApi = SchemeApi;
/**
 * SchemeChangesApi - axios parameter creator
 * @export
 */
const SchemeChangesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get scheme edits
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistory: (schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('getSchemeHistory', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/history`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get scheme edits, done by other user
         * @param {string} otherUser
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistoryForUser: (otherUser, schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'otherUser' is not null or undefined
            (0, common_1.assertParamExists)('getSchemeHistoryForUser', 'otherUser', otherUser);
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('getSchemeHistoryForUser', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/history/{otherUser}`
                .replace(`{${"otherUser"}}`, encodeURIComponent(String(otherUser)))
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {Array<number>} [changes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangesSchemeIdApplyChangesPost: (schemeId, changes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeChangesSchemeIdApplyChangesPost', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/applyChanges`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (changes) {
                localVarQueryParameter['changes'] = changes;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangesSchemeIdEditorsGet: (schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeChangesSchemeIdEditorsGet', 'schemeId', schemeId);
            const localVarPath = `/schemeChanges/{schemeId}/editors`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SchemeChangesApiAxiosParamCreator = SchemeChangesApiAxiosParamCreator;
/**
 * SchemeChangesApi - functional programming interface
 * @export
 */
const SchemeChangesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SchemeChangesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get scheme edits
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistory(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchemeHistory(schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get scheme edits, done by other user
         * @param {string} otherUser
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistoryForUser(otherUser, schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSchemeHistoryForUser(otherUser, schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {Array<number>} [changes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangesSchemeIdApplyChangesPost(schemeId, changes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeChangesSchemeIdApplyChangesPost(schemeId, changes, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangesSchemeIdEditorsGet(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeChangesSchemeIdEditorsGet(schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SchemeChangesApiFp = SchemeChangesApiFp;
/**
 * SchemeChangesApi - factory interface
 * @export
 */
const SchemeChangesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SchemeChangesApiFp)(configuration);
    return {
        /**
         * Get scheme edits
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistory(schemeId, options) {
            return localVarFp.getSchemeHistory(schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get scheme edits, done by other user
         * @param {string} otherUser
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemeHistoryForUser(otherUser, schemeId, options) {
            return localVarFp.getSchemeHistoryForUser(otherUser, schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {Array<number>} [changes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangesSchemeIdApplyChangesPost(schemeId, changes, options) {
            return localVarFp.schemeChangesSchemeIdApplyChangesPost(schemeId, changes, options).then((request) => request(axios, basePath));
        },
        /**
         * Get other users that have edited the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeChangesSchemeIdEditorsGet(schemeId, options) {
            return localVarFp.schemeChangesSchemeIdEditorsGet(schemeId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SchemeChangesApiFactory = SchemeChangesApiFactory;
/**
 * SchemeChangesApi - object-oriented interface
 * @export
 * @class SchemeChangesApi
 * @extends {BaseAPI}
 */
class SchemeChangesApi extends base_1.BaseAPI {
    /**
     * Get scheme edits
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    getSchemeHistory(schemeId, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).getSchemeHistory(schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get scheme edits, done by other user
     * @param {string} otherUser
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    getSchemeHistoryForUser(otherUser, schemeId, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).getSchemeHistoryForUser(otherUser, schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get other users that have edited the scheme
     * @param {string} schemeId
     * @param {Array<number>} [changes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    schemeChangesSchemeIdApplyChangesPost(schemeId, changes, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).schemeChangesSchemeIdApplyChangesPost(schemeId, changes, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get other users that have edited the scheme
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeChangesApi
     */
    schemeChangesSchemeIdEditorsGet(schemeId, options) {
        return (0, exports.SchemeChangesApiFp)(this.configuration).schemeChangesSchemeIdEditorsGet(schemeId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SchemeChangesApi = SchemeChangesApi;
/**
 * SchemeItemApi - axios parameter creator
 * @export
 */
const SchemeItemApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns whether the iten exists in the database
         * @param {string} schemeId
         * @param {Array<string>} [itemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemExistsSchemeIdGet: (schemeId, itemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeitemsItemExistsSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/schemeitems/itemExists/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId) {
                localVarQueryParameter['itemId'] = itemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get item gis information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemGisInfoPost: (getItemByIdsRequestParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemeitems/itemGisInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemByIdsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get items from scheme based on parameters
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemsByTagPost: (getItemsByTagsRequestParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemeitems/itemsByTag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemsByTagsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get basic item information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsSimplifiedItemsByIdPost: (getItemByIdsRequestParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemeitems/simplifiedItemsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemByIdsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get basic item information allong with the requested tags
         * @param {Array<string>} [type]
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsSimplifiedItemsBytagPost: (type, getItemsByTagsRequestParameters, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/schemeitems/simplifiedItemsBytag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getItemsByTagsRequestParameters, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SchemeItemApiAxiosParamCreator = SchemeItemApiAxiosParamCreator;
/**
 * SchemeItemApi - functional programming interface
 * @export
 */
const SchemeItemApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SchemeItemApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns whether the iten exists in the database
         * @param {string} schemeId
         * @param {Array<string>} [itemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemExistsSchemeIdGet(schemeId, itemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemsItemExistsSchemeIdGet(schemeId, itemId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get item gis information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemGisInfoPost(getItemByIdsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemsItemGisInfoPost(getItemByIdsRequestParameters, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get items from scheme based on parameters
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemsByTagPost(getItemsByTagsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemsItemsByTagPost(getItemsByTagsRequestParameters, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get basic item information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsSimplifiedItemsByIdPost(getItemByIdsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemsSimplifiedItemsByIdPost(getItemByIdsRequestParameters, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get basic item information allong with the requested tags
         * @param {Array<string>} [type]
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsSimplifiedItemsBytagPost(type, getItemsByTagsRequestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeitemsSimplifiedItemsBytagPost(type, getItemsByTagsRequestParameters, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SchemeItemApiFp = SchemeItemApiFp;
/**
 * SchemeItemApi - factory interface
 * @export
 */
const SchemeItemApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SchemeItemApiFp)(configuration);
    return {
        /**
         * Returns whether the iten exists in the database
         * @param {string} schemeId
         * @param {Array<string>} [itemId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemExistsSchemeIdGet(schemeId, itemId, options) {
            return localVarFp.schemeitemsItemExistsSchemeIdGet(schemeId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get item gis information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemGisInfoPost(getItemByIdsRequestParameters, options) {
            return localVarFp.schemeitemsItemGisInfoPost(getItemByIdsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get items from scheme based on parameters
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsItemsByTagPost(getItemsByTagsRequestParameters, options) {
            return localVarFp.schemeitemsItemsByTagPost(getItemsByTagsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get basic item information
         * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsSimplifiedItemsByIdPost(getItemByIdsRequestParameters, options) {
            return localVarFp.schemeitemsSimplifiedItemsByIdPost(getItemByIdsRequestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Get basic item information allong with the requested tags
         * @param {Array<string>} [type]
         * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeitemsSimplifiedItemsBytagPost(type, getItemsByTagsRequestParameters, options) {
            return localVarFp.schemeitemsSimplifiedItemsBytagPost(type, getItemsByTagsRequestParameters, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SchemeItemApiFactory = SchemeItemApiFactory;
/**
 * SchemeItemApi - object-oriented interface
 * @export
 * @class SchemeItemApi
 * @extends {BaseAPI}
 */
class SchemeItemApi extends base_1.BaseAPI {
    /**
     * Returns whether the iten exists in the database
     * @param {string} schemeId
     * @param {Array<string>} [itemId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemsItemExistsSchemeIdGet(schemeId, itemId, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemsItemExistsSchemeIdGet(schemeId, itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get item gis information
     * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemsItemGisInfoPost(getItemByIdsRequestParameters, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemsItemGisInfoPost(getItemByIdsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get items from scheme based on parameters
     * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemsItemsByTagPost(getItemsByTagsRequestParameters, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemsItemsByTagPost(getItemsByTagsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get basic item information
     * @param {GetItemByIdsRequestParameters} [getItemByIdsRequestParameters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemsSimplifiedItemsByIdPost(getItemByIdsRequestParameters, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemsSimplifiedItemsByIdPost(getItemByIdsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get basic item information allong with the requested tags
     * @param {Array<string>} [type]
     * @param {GetItemsByTagsRequestParameters} [getItemsByTagsRequestParameters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeItemApi
     */
    schemeitemsSimplifiedItemsBytagPost(type, getItemsByTagsRequestParameters, options) {
        return (0, exports.SchemeItemApiFp)(this.configuration).schemeitemsSimplifiedItemsBytagPost(type, getItemsByTagsRequestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SchemeItemApi = SchemeItemApi;
/**
 * ServerApi - axios parameter creator
 * @export
 */
const ServerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {boolean} prodMode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverAProdModeGet: (prodMode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'prodMode' is not null or undefined
            (0, common_1.assertParamExists)('serverAProdModeGet', 'prodMode', prodMode);
            const localVarPath = `/server/{a}/{prodMode}`
                .replace(`{${"prodMode"}}`, encodeURIComponent(String(prodMode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [errors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverBreakerRemotedatasetsGet: (errors, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/breaker/remotedatasets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (errors !== undefined) {
                localVarQueryParameter['errors'] = errors;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverBuildIdGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/buildId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverDeploymentColorGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/deploymentColor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverEnableScheduledTasksGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/enableScheduledTasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [property]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverGetSystemPropertyGet: (property, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/getSystemProperty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (property !== undefined) {
                localVarQueryParameter['property'] = property;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverHeadersGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/headers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverHealthGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [level]
         * @param {string} [logger]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverLoglevelGet: (level, logger, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/loglevel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }
            if (logger !== undefined) {
                localVarQueryParameter['logger'] = logger;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverQuartzSchedulesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/quartzSchedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [property]
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverSetSystemPropertyGet: (property, value, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/setSystemProperty`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (property !== undefined) {
                localVarQueryParameter['property'] = property;
            }
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStackLogClearGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/stack-log/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStackLogGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/stack-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStartupIdentifierGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/startupIdentifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverSwapSuccessCallbackGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/swapSuccessCallback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverTestingGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/testing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverVersionGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/server/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ServerApiAxiosParamCreator = ServerApiAxiosParamCreator;
/**
 * ServerApi - functional programming interface
 * @export
 */
const ServerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {boolean} prodMode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverAProdModeGet(prodMode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverAProdModeGet(prodMode, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [errors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverBreakerRemotedatasetsGet(errors, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverBreakerRemotedatasetsGet(errors, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverBuildIdGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverBuildIdGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverDeploymentColorGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverDeploymentColorGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverEnableScheduledTasksGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverEnableScheduledTasksGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [property]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverGetSystemPropertyGet(property, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverGetSystemPropertyGet(property, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverHeadersGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverHeadersGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverHealthGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverHealthGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [level]
         * @param {string} [logger]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverLoglevelGet(level, logger, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverLoglevelGet(level, logger, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverQuartzSchedulesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverQuartzSchedulesGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [property]
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverSetSystemPropertyGet(property, value, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverSetSystemPropertyGet(property, value, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStackLogClearGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverStackLogClearGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStackLogGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverStackLogGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStartupIdentifierGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverStartupIdentifierGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverSwapSuccessCallbackGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverSwapSuccessCallbackGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverTestingGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverTestingGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverVersionGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.serverVersionGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ServerApiFp = ServerApiFp;
/**
 * ServerApi - factory interface
 * @export
 */
const ServerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServerApiFp)(configuration);
    return {
        /**
         *
         * @param {boolean} prodMode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverAProdModeGet(prodMode, options) {
            return localVarFp.serverAProdModeGet(prodMode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [errors]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverBreakerRemotedatasetsGet(errors, options) {
            return localVarFp.serverBreakerRemotedatasetsGet(errors, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverBuildIdGet(options) {
            return localVarFp.serverBuildIdGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverDeploymentColorGet(options) {
            return localVarFp.serverDeploymentColorGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverEnableScheduledTasksGet(options) {
            return localVarFp.serverEnableScheduledTasksGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [property]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverGetSystemPropertyGet(property, options) {
            return localVarFp.serverGetSystemPropertyGet(property, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverHeadersGet(options) {
            return localVarFp.serverHeadersGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverHealthGet(options) {
            return localVarFp.serverHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [level]
         * @param {string} [logger]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverLoglevelGet(level, logger, options) {
            return localVarFp.serverLoglevelGet(level, logger, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverQuartzSchedulesGet(options) {
            return localVarFp.serverQuartzSchedulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [property]
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverSetSystemPropertyGet(property, value, options) {
            return localVarFp.serverSetSystemPropertyGet(property, value, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStackLogClearGet(options) {
            return localVarFp.serverStackLogClearGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStackLogGet(options) {
            return localVarFp.serverStackLogGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverStartupIdentifierGet(options) {
            return localVarFp.serverStartupIdentifierGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverSwapSuccessCallbackGet(options) {
            return localVarFp.serverSwapSuccessCallbackGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverTestingGet(options) {
            return localVarFp.serverTestingGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serverVersionGet(options) {
            return localVarFp.serverVersionGet(options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServerApiFactory = ServerApiFactory;
/**
 * ServerApi - object-oriented interface
 * @export
 * @class ServerApi
 * @extends {BaseAPI}
 */
class ServerApi extends base_1.BaseAPI {
    /**
     *
     * @param {boolean} prodMode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverAProdModeGet(prodMode, options) {
        return (0, exports.ServerApiFp)(this.configuration).serverAProdModeGet(prodMode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [errors]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverBreakerRemotedatasetsGet(errors, options) {
        return (0, exports.ServerApiFp)(this.configuration).serverBreakerRemotedatasetsGet(errors, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverBuildIdGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverBuildIdGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverDeploymentColorGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverDeploymentColorGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverEnableScheduledTasksGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverEnableScheduledTasksGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [property]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverGetSystemPropertyGet(property, options) {
        return (0, exports.ServerApiFp)(this.configuration).serverGetSystemPropertyGet(property, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverHeadersGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverHeadersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverHealthGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [level]
     * @param {string} [logger]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverLoglevelGet(level, logger, options) {
        return (0, exports.ServerApiFp)(this.configuration).serverLoglevelGet(level, logger, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverQuartzSchedulesGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverQuartzSchedulesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [property]
     * @param {string} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverSetSystemPropertyGet(property, value, options) {
        return (0, exports.ServerApiFp)(this.configuration).serverSetSystemPropertyGet(property, value, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverStackLogClearGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverStackLogClearGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverStackLogGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverStackLogGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverStartupIdentifierGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverStartupIdentifierGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverSwapSuccessCallbackGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverSwapSuccessCallbackGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverTestingGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverTestingGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    serverVersionGet(options) {
        return (0, exports.ServerApiFp)(this.configuration).serverVersionGet(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServerApi = ServerApi;
/**
 * ServiceConfigurationBackupApi - axios parameter creator
 * @export
 */
const ServiceConfigurationBackupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} configId
         * @param {string} serviceId
         * @param {string} serviceType
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servicesConfigurationBackupServiceTypeServiceIdConfigIdPost: (configId, serviceId, serviceType, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configId' is not null or undefined
            (0, common_1.assertParamExists)('servicesConfigurationBackupServiceTypeServiceIdConfigIdPost', 'configId', configId);
            // verify required parameter 'serviceId' is not null or undefined
            (0, common_1.assertParamExists)('servicesConfigurationBackupServiceTypeServiceIdConfigIdPost', 'serviceId', serviceId);
            // verify required parameter 'serviceType' is not null or undefined
            (0, common_1.assertParamExists)('servicesConfigurationBackupServiceTypeServiceIdConfigIdPost', 'serviceType', serviceType);
            const localVarPath = `/services/configurationBackup/{serviceType}/{serviceId}/{configId}`
                .replace(`{${"configId"}}`, encodeURIComponent(String(configId)))
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)))
                .replace(`{${"serviceType"}}`, encodeURIComponent(String(serviceType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ServiceConfigurationBackupApiAxiosParamCreator = ServiceConfigurationBackupApiAxiosParamCreator;
/**
 * ServiceConfigurationBackupApi - functional programming interface
 * @export
 */
const ServiceConfigurationBackupApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServiceConfigurationBackupApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} configId
         * @param {string} serviceId
         * @param {string} serviceType
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servicesConfigurationBackupServiceTypeServiceIdConfigIdPost(configId, serviceId, serviceType, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.servicesConfigurationBackupServiceTypeServiceIdConfigIdPost(configId, serviceId, serviceType, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ServiceConfigurationBackupApiFp = ServiceConfigurationBackupApiFp;
/**
 * ServiceConfigurationBackupApi - factory interface
 * @export
 */
const ServiceConfigurationBackupApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServiceConfigurationBackupApiFp)(configuration);
    return {
        /**
         *
         * @param {string} configId
         * @param {string} serviceId
         * @param {string} serviceType
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        servicesConfigurationBackupServiceTypeServiceIdConfigIdPost(configId, serviceId, serviceType, body, options) {
            return localVarFp.servicesConfigurationBackupServiceTypeServiceIdConfigIdPost(configId, serviceId, serviceType, body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServiceConfigurationBackupApiFactory = ServiceConfigurationBackupApiFactory;
/**
 * ServiceConfigurationBackupApi - object-oriented interface
 * @export
 * @class ServiceConfigurationBackupApi
 * @extends {BaseAPI}
 */
class ServiceConfigurationBackupApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} configId
     * @param {string} serviceId
     * @param {string} serviceType
     * @param {object} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceConfigurationBackupApi
     */
    servicesConfigurationBackupServiceTypeServiceIdConfigIdPost(configId, serviceId, serviceType, body, options) {
        return (0, exports.ServiceConfigurationBackupApiFp)(this.configuration).servicesConfigurationBackupServiceTypeServiceIdConfigIdPost(configId, serviceId, serviceType, body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServiceConfigurationBackupApi = ServiceConfigurationBackupApi;
/**
 * SoftwareUpdatesApi - axios parameter creator
 * @export
 */
const SoftwareUpdatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsCreatePost: (appInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/applications/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appInfo, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsDeleteAppStreamVersionDelete: (app, stream, version, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('applicationsDeleteAppStreamVersionDelete', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('applicationsDeleteAppStreamVersionDelete', 'stream', stream);
            // verify required parameter 'version' is not null or undefined
            (0, common_1.assertParamExists)('applicationsDeleteAppStreamVersionDelete', 'version', version);
            const localVarPath = `/applications/delete/{app}/{stream}/{version}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsDownloadAppStreamVersionGet: (app, stream, version, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('applicationsDownloadAppStreamVersionGet', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('applicationsDownloadAppStreamVersionGet', 'stream', stream);
            // verify required parameter 'version' is not null or undefined
            (0, common_1.assertParamExists)('applicationsDownloadAppStreamVersionGet', 'version', version);
            const localVarPath = `/applications/download/{app}/{stream}/{version}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUpdateInfoAppStreamGet: (app, stream, from, to, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('applicationsUpdateInfoAppStreamGet', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('applicationsUpdateInfoAppStreamGet', 'stream', stream);
            const localVarPath = `/applications/updateInfo/{app}/{stream}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUpdatePost: (appInfo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/applications/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(appInfo, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUploadAppStreamPost: (app, stream, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('applicationsUploadAppStreamPost', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('applicationsUploadAppStreamPost', 'stream', stream);
            const localVarPath = `/applications/upload/{app}/{stream}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsVersionAppStreamGet: (app, stream, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('applicationsVersionAppStreamGet', 'app', app);
            // verify required parameter 'stream' is not null or undefined
            (0, common_1.assertParamExists)('applicationsVersionAppStreamGet', 'stream', stream);
            const localVarPath = `/applications/version/{app}/{stream}`
                .replace(`{${"app"}}`, encodeURIComponent(String(app)))
                .replace(`{${"stream"}}`, encodeURIComponent(String(stream)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SoftwareUpdatesApiAxiosParamCreator = SoftwareUpdatesApiAxiosParamCreator;
/**
 * SoftwareUpdatesApi - functional programming interface
 * @export
 */
const SoftwareUpdatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SoftwareUpdatesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsCreatePost(appInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsCreatePost(appInfo, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsDeleteAppStreamVersionDelete(app, stream, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsDeleteAppStreamVersionDelete(app, stream, version, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsDownloadAppStreamVersionGet(app, stream, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsDownloadAppStreamVersionGet(app, stream, version, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUpdateInfoAppStreamGet(app, stream, from, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsUpdateInfoAppStreamGet(app, stream, from, to, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUpdatePost(appInfo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsUpdatePost(appInfo, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUploadAppStreamPost(app, stream, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsUploadAppStreamPost(app, stream, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsVersionAppStreamGet(app, stream, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.applicationsVersionAppStreamGet(app, stream, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SoftwareUpdatesApiFp = SoftwareUpdatesApiFp;
/**
 * SoftwareUpdatesApi - factory interface
 * @export
 */
const SoftwareUpdatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SoftwareUpdatesApiFp)(configuration);
    return {
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsCreatePost(appInfo, options) {
            return localVarFp.applicationsCreatePost(appInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsDeleteAppStreamVersionDelete(app, stream, version, options) {
            return localVarFp.applicationsDeleteAppStreamVersionDelete(app, stream, version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsDownloadAppStreamVersionGet(app, stream, version, options) {
            return localVarFp.applicationsDownloadAppStreamVersionGet(app, stream, version, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {string} [from]
         * @param {string} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUpdateInfoAppStreamGet(app, stream, from, to, options) {
            return localVarFp.applicationsUpdateInfoAppStreamGet(app, stream, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AppInfo} [appInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUpdatePost(appInfo, options) {
            return localVarFp.applicationsUpdatePost(appInfo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsUploadAppStreamPost(app, stream, options) {
            return localVarFp.applicationsUploadAppStreamPost(app, stream, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} app
         * @param {string} stream
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applicationsVersionAppStreamGet(app, stream, options) {
            return localVarFp.applicationsVersionAppStreamGet(app, stream, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SoftwareUpdatesApiFactory = SoftwareUpdatesApiFactory;
/**
 * SoftwareUpdatesApi - object-oriented interface
 * @export
 * @class SoftwareUpdatesApi
 * @extends {BaseAPI}
 */
class SoftwareUpdatesApi extends base_1.BaseAPI {
    /**
     *
     * @param {AppInfo} [appInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsCreatePost(appInfo, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsCreatePost(appInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} app
     * @param {string} stream
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsDeleteAppStreamVersionDelete(app, stream, version, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsDeleteAppStreamVersionDelete(app, stream, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} app
     * @param {string} stream
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsDownloadAppStreamVersionGet(app, stream, version, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsDownloadAppStreamVersionGet(app, stream, version, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} app
     * @param {string} stream
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsUpdateInfoAppStreamGet(app, stream, from, to, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsUpdateInfoAppStreamGet(app, stream, from, to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppInfo} [appInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsUpdatePost(appInfo, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsUpdatePost(appInfo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} app
     * @param {string} stream
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsUploadAppStreamPost(app, stream, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsUploadAppStreamPost(app, stream, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} app
     * @param {string} stream
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwareUpdatesApi
     */
    applicationsVersionAppStreamGet(app, stream, options) {
        return (0, exports.SoftwareUpdatesApiFp)(this.configuration).applicationsVersionAppStreamGet(app, stream, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SoftwareUpdatesApi = SoftwareUpdatesApi;
/**
 * TagApi - axios parameter creator
 * @export
 */
const TagApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Gel all tag values present in scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsAllTagValuesSchemeIdGet: (schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagsAllTagValuesSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/tags/allTagValues/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a map of lists of compatible tags for eatch requested type
         * @param {string} schemeId
         * @param {Array<string>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsCompatibleTagsSchemeIdGet: (schemeId, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagsCompatibleTagsSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/tags/compatibleTags/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
         * @param {string} schemeId
         * @param {RelevantTagValueRequestData} [relevantTagValueRequestData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsRelevantTagsSchemeIdPost: (schemeId, relevantTagValueRequestData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagsRelevantTagsSchemeIdPost', 'schemeId', schemeId);
            const localVarPath = `/tags/relevantTags/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(relevantTagValueRequestData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get tag ids present in a scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsSchemeIdGet: (schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagsSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/tags/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get info of specified tags
         * @param {string} schemeId
         * @param {Array<string>} [tagId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsTagInfoSchemeIdGet: (schemeId, tagId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagsTagInfoSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/tags/tagInfo/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (tagId) {
                localVarQueryParameter['tagId'] = tagId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of tag trees defined for the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsTagTreesSchemeIdGet: (schemeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('tagsTagTreesSchemeIdGet', 'schemeId', schemeId);
            const localVarPath = `/tags/tagTrees/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TagApiAxiosParamCreator = TagApiAxiosParamCreator;
/**
 * TagApi - functional programming interface
 * @export
 */
const TagApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TagApiAxiosParamCreator)(configuration);
    return {
        /**
         * Gel all tag values present in scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsAllTagValuesSchemeIdGet(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsAllTagValuesSchemeIdGet(schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a map of lists of compatible tags for eatch requested type
         * @param {string} schemeId
         * @param {Array<string>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsCompatibleTagsSchemeIdGet(schemeId, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsCompatibleTagsSchemeIdGet(schemeId, type, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
         * @param {string} schemeId
         * @param {RelevantTagValueRequestData} [relevantTagValueRequestData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsRelevantTagsSchemeIdPost(schemeId, relevantTagValueRequestData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsRelevantTagsSchemeIdPost(schemeId, relevantTagValueRequestData, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get tag ids present in a scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsSchemeIdGet(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsSchemeIdGet(schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get info of specified tags
         * @param {string} schemeId
         * @param {Array<string>} [tagId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsTagInfoSchemeIdGet(schemeId, tagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsTagInfoSchemeIdGet(schemeId, tagId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get list of tag trees defined for the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsTagTreesSchemeIdGet(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsTagTreesSchemeIdGet(schemeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TagApiFp = TagApiFp;
/**
 * TagApi - factory interface
 * @export
 */
const TagApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TagApiFp)(configuration);
    return {
        /**
         * Gel all tag values present in scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsAllTagValuesSchemeIdGet(schemeId, options) {
            return localVarFp.tagsAllTagValuesSchemeIdGet(schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a map of lists of compatible tags for eatch requested type
         * @param {string} schemeId
         * @param {Array<string>} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsCompatibleTagsSchemeIdGet(schemeId, type, options) {
            return localVarFp.tagsCompatibleTagsSchemeIdGet(schemeId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
         * @param {string} schemeId
         * @param {RelevantTagValueRequestData} [relevantTagValueRequestData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsRelevantTagsSchemeIdPost(schemeId, relevantTagValueRequestData, options) {
            return localVarFp.tagsRelevantTagsSchemeIdPost(schemeId, relevantTagValueRequestData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tag ids present in a scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsSchemeIdGet(schemeId, options) {
            return localVarFp.tagsSchemeIdGet(schemeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get info of specified tags
         * @param {string} schemeId
         * @param {Array<string>} [tagId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsTagInfoSchemeIdGet(schemeId, tagId, options) {
            return localVarFp.tagsTagInfoSchemeIdGet(schemeId, tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of tag trees defined for the scheme
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsTagTreesSchemeIdGet(schemeId, options) {
            return localVarFp.tagsTagTreesSchemeIdGet(schemeId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TagApiFactory = TagApiFactory;
/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
class TagApi extends base_1.BaseAPI {
    /**
     * Gel all tag values present in scheme
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagsAllTagValuesSchemeIdGet(schemeId, options) {
        return (0, exports.TagApiFp)(this.configuration).tagsAllTagValuesSchemeIdGet(schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a map of lists of compatible tags for eatch requested type
     * @param {string} schemeId
     * @param {Array<string>} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagsCompatibleTagsSchemeIdGet(schemeId, type, options) {
        return (0, exports.TagApiFp)(this.configuration).tagsCompatibleTagsSchemeIdGet(schemeId, type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return a list of tag values that would return non-empty results if used as filter allong with given filterValues. If tagId is null, return values for all tags.
     * @param {string} schemeId
     * @param {RelevantTagValueRequestData} [relevantTagValueRequestData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagsRelevantTagsSchemeIdPost(schemeId, relevantTagValueRequestData, options) {
        return (0, exports.TagApiFp)(this.configuration).tagsRelevantTagsSchemeIdPost(schemeId, relevantTagValueRequestData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get tag ids present in a scheme
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagsSchemeIdGet(schemeId, options) {
        return (0, exports.TagApiFp)(this.configuration).tagsSchemeIdGet(schemeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get info of specified tags
     * @param {string} schemeId
     * @param {Array<string>} [tagId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagsTagInfoSchemeIdGet(schemeId, tagId, options) {
        return (0, exports.TagApiFp)(this.configuration).tagsTagInfoSchemeIdGet(schemeId, tagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of tag trees defined for the scheme
     * @param {string} schemeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    tagsTagTreesSchemeIdGet(schemeId, options) {
        return (0, exports.TagApiFp)(this.configuration).tagsTagTreesSchemeIdGet(schemeId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TagApi = TagApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} token
         * @param {string} [redirect]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersActivateEmailTokenGet: (token, redirect, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'token' is not null or undefined
            (0, common_1.assertParamExists)('usersActivateEmailTokenGet', 'token', token);
            const localVarPath = `/users/activateEmail/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (redirect !== undefined) {
                localVarQueryParameter['redirect'] = redirect;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAuthGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body New email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangeEmailPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersChangeEmailPost', 'body', body);
            const localVarPath = `/users/changeEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ChangePasswordDTO} changePasswordDTO Change password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangePasswordPost: (changePasswordDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'changePasswordDTO' is not null or undefined
            (0, common_1.assertParamExists)('usersChangePasswordPost', 'changePasswordDTO', changePasswordDTO);
            const localVarPath = `/users/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePasswordDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailExistsPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersEmailExistsPost', 'body', body);
            const localVarPath = `/users/emailExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersExternalUsersUserIdGet: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usersExternalUsersUserIdGet', 'userId', userId);
            const localVarPath = `/users/externalUsers/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [hasPermission]
         * @param {string} [hasRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet: (hasPermission, hasRole, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (hasPermission !== undefined) {
                localVarQueryParameter['hasPermission'] = hasPermission;
            }
            if (hasRole !== undefined) {
                localVarQueryParameter['hasRole'] = hasRole;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInfoGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [xKeycloakUserlessToken]
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInitialSetupPost: (xKeycloakUserlessToken, initialSetupRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/initialSetup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (xKeycloakUserlessToken != null) {
                localVarHeaderParameter['x-keycloak-userless-token'] = String(xKeycloakUserlessToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initialSetupRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [permission]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIsPermittedGet: (permission, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/isPermitted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (permission) {
                localVarQueryParameter['permission'] = permission;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [createUsers]
         * @param {string} [xKeycloakUserlessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersKeycloakUsersGet: (createUsers, xKeycloakUserlessToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/keycloakUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (createUsers !== undefined) {
                localVarQueryParameter['createUsers'] = createUsers;
            }
            if (xKeycloakUserlessToken != null) {
                localVarHeaderParameter['x-keycloak-userless-token'] = String(xKeycloakUserlessToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersLoginGooglePost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersLoginGooglePost', 'body', body);
            const localVarPath = `/users/loginGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body googleToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersNameExistsGooglePost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersNameExistsGooglePost', 'body', body);
            const localVarPath = `/users/nameExistsGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersNameExistsPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersNameExistsPost', 'body', body);
            const localVarPath = `/users/nameExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPermissionsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterGooglePost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersRegisterGooglePost', 'body', body);
            const localVarPath = `/users/registerGoogle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {object} body creationInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersRegisterPost', 'body', body);
            const localVarPath = `/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} body username
         * @param {string} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRequestResetPasswordPost: (body, from, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('usersRequestResetPasswordPost', 'body', body);
            const localVarPath = `/users/requestResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ResetPasswordWithTokenDTO} resetPasswordWithTokenDTO Reset password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersResetPasswordPost: (resetPasswordWithTokenDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resetPasswordWithTokenDTO' is not null or undefined
            (0, common_1.assertParamExists)('usersResetPasswordPost', 'resetPasswordWithTokenDTO', resetPasswordWithTokenDTO);
            const localVarPath = `/users/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPasswordWithTokenDTO, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [from]
         * @param {number} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersStatisticsGet: (from, to, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUsernameInfoGet: (username, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'username' is not null or undefined
            (0, common_1.assertParamExists)('usersUsernameInfoGet', 'username', username);
            const localVarPath = `/users/{username}/info`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {string} [redirect]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersActivateEmailTokenGet(token, redirect, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersActivateEmailTokenGet(token, redirect, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAuthGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersAuthGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body New email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangeEmailPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersChangeEmailPost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ChangePasswordDTO} changePasswordDTO Change password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangePasswordPost(changePasswordDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersChangePasswordPost(changePasswordDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailExistsPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersEmailExistsPost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersExternalUsersUserIdGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersExternalUsersUserIdGet(userId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [hasPermission]
         * @param {string} [hasRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet(hasPermission, hasRole, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersGet(hasPermission, hasRole, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInfoGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersInfoGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [xKeycloakUserlessToken]
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInitialSetupPost(xKeycloakUserlessToken, initialSetupRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersInitialSetupPost(xKeycloakUserlessToken, initialSetupRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} [permission]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIsPermittedGet(permission, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersIsPermittedGet(permission, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [createUsers]
         * @param {string} [xKeycloakUserlessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersKeycloakUsersGet(createUsers, xKeycloakUserlessToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersKeycloakUsersGet(createUsers, xKeycloakUserlessToken, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {object} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersLoginGooglePost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersLoginGooglePost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body googleToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersNameExistsGooglePost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersNameExistsGooglePost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersNameExistsPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersNameExistsPost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPermissionsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersPermissionsGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterGooglePost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersRegisterGooglePost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {object} body creationInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersRegisterPost(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} body username
         * @param {string} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRequestResetPasswordPost(body, from, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersRequestResetPasswordPost(body, from, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ResetPasswordWithTokenDTO} resetPasswordWithTokenDTO Reset password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersResetPasswordPost(resetPasswordWithTokenDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersResetPasswordPost(resetPasswordWithTokenDTO, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [from]
         * @param {number} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersStatisticsGet(from, to, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersStatisticsGet(from, to, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUsernameInfoGet(username, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersUsernameInfoGet(username, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @param {string} token
         * @param {string} [redirect]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersActivateEmailTokenGet(token, redirect, options) {
            return localVarFp.usersActivateEmailTokenGet(token, redirect, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersAuthGet(options) {
            return localVarFp.usersAuthGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body New email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangeEmailPost(body, options) {
            return localVarFp.usersChangeEmailPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ChangePasswordDTO} changePasswordDTO Change password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersChangePasswordPost(changePasswordDTO, options) {
            return localVarFp.usersChangePasswordPost(changePasswordDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersEmailExistsPost(body, options) {
            return localVarFp.usersEmailExistsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersExternalUsersUserIdGet(userId, options) {
            return localVarFp.usersExternalUsersUserIdGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [hasPermission]
         * @param {string} [hasRole]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGet(hasPermission, hasRole, options) {
            return localVarFp.usersGet(hasPermission, hasRole, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInfoGet(options) {
            return localVarFp.usersInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [xKeycloakUserlessToken]
         * @param {InitialSetupRequest} [initialSetupRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersInitialSetupPost(xKeycloakUserlessToken, initialSetupRequest, options) {
            return localVarFp.usersInitialSetupPost(xKeycloakUserlessToken, initialSetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} [permission]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersIsPermittedGet(permission, options) {
            return localVarFp.usersIsPermittedGet(permission, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [createUsers]
         * @param {string} [xKeycloakUserlessToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersKeycloakUsersGet(createUsers, xKeycloakUserlessToken, options) {
            return localVarFp.usersKeycloakUsersGet(createUsers, xKeycloakUserlessToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersLoginGooglePost(body, options) {
            return localVarFp.usersLoginGooglePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body googleToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersNameExistsGooglePost(body, options) {
            return localVarFp.usersNameExistsGooglePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersNameExistsPost(body, options) {
            return localVarFp.usersNameExistsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPermissionsGet(options) {
            return localVarFp.usersPermissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body google token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterGooglePost(body, options) {
            return localVarFp.usersRegisterGooglePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {object} body creationInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRegisterPost(body, options) {
            return localVarFp.usersRegisterPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} body username
         * @param {string} [from]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRequestResetPasswordPost(body, from, options) {
            return localVarFp.usersRequestResetPasswordPost(body, from, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ResetPasswordWithTokenDTO} resetPasswordWithTokenDTO Reset password info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersResetPasswordPost(resetPasswordWithTokenDTO, options) {
            return localVarFp.usersResetPasswordPost(resetPasswordWithTokenDTO, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [from]
         * @param {number} [to]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersStatisticsGet(from, to, options) {
            return localVarFp.usersStatisticsGet(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUsernameInfoGet(username, options) {
            return localVarFp.usersUsernameInfoGet(username, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
class UserApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} token
     * @param {string} [redirect]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersActivateEmailTokenGet(token, redirect, options) {
        return (0, exports.UserApiFp)(this.configuration).usersActivateEmailTokenGet(token, redirect, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersAuthGet(options) {
        return (0, exports.UserApiFp)(this.configuration).usersAuthGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body New email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersChangeEmailPost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersChangeEmailPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChangePasswordDTO} changePasswordDTO Change password info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersChangePasswordPost(changePasswordDTO, options) {
        return (0, exports.UserApiFp)(this.configuration).usersChangePasswordPost(changePasswordDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersEmailExistsPost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersEmailExistsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersExternalUsersUserIdGet(userId, options) {
        return (0, exports.UserApiFp)(this.configuration).usersExternalUsersUserIdGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [hasPermission]
     * @param {string} [hasRole]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersGet(hasPermission, hasRole, options) {
        return (0, exports.UserApiFp)(this.configuration).usersGet(hasPermission, hasRole, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersInfoGet(options) {
        return (0, exports.UserApiFp)(this.configuration).usersInfoGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [xKeycloakUserlessToken]
     * @param {InitialSetupRequest} [initialSetupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersInitialSetupPost(xKeycloakUserlessToken, initialSetupRequest, options) {
        return (0, exports.UserApiFp)(this.configuration).usersInitialSetupPost(xKeycloakUserlessToken, initialSetupRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<string>} [permission]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersIsPermittedGet(permission, options) {
        return (0, exports.UserApiFp)(this.configuration).usersIsPermittedGet(permission, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [createUsers]
     * @param {string} [xKeycloakUserlessToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersKeycloakUsersGet(createUsers, xKeycloakUserlessToken, options) {
        return (0, exports.UserApiFp)(this.configuration).usersKeycloakUsersGet(createUsers, xKeycloakUserlessToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} body google token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersLoginGooglePost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersLoginGooglePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body googleToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersNameExistsGooglePost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersNameExistsGooglePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersNameExistsPost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersNameExistsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersPermissionsGet(options) {
        return (0, exports.UserApiFp)(this.configuration).usersPermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body google token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersRegisterGooglePost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersRegisterGooglePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {object} body creationInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersRegisterPost(body, options) {
        return (0, exports.UserApiFp)(this.configuration).usersRegisterPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} body username
     * @param {string} [from]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersRequestResetPasswordPost(body, from, options) {
        return (0, exports.UserApiFp)(this.configuration).usersRequestResetPasswordPost(body, from, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ResetPasswordWithTokenDTO} resetPasswordWithTokenDTO Reset password info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersResetPasswordPost(resetPasswordWithTokenDTO, options) {
        return (0, exports.UserApiFp)(this.configuration).usersResetPasswordPost(resetPasswordWithTokenDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [from]
     * @param {number} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersStatisticsGet(from, to, options) {
        return (0, exports.UserApiFp)(this.configuration).usersStatisticsGet(from, to, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    usersUsernameInfoGet(username, options) {
        return (0, exports.UserApiFp)(this.configuration).usersUsernameInfoGet(username, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserApi = UserApi;
//# sourceMappingURL=api.js.map